export const translations = {
    locale: "en",
    get: (id, parameters) => {
        if (!id)
            return "";
        const object = translations[translations.locale] ?? translations.en;
        let translation = object[id] ?? translations.en[id] ?? "";
        if (!translation) {
            console.error("Missing translation for '" + id + "'");
            translation = id;
        }
        if (parameters) {
            for (const param in parameters)
                translation = translation.replaceAll("{" + param + "}", parameters[param] + "");
        }
        return translation;
    },
    en: {
        UnlockPlatinum: "Unlock Platinum",
        UpgradePlatinumDescription: "Upgrade to Platinum for your team. Manage user permissions and access advanced features designed for administrators.",
        AdvancedTeamManagement: "Advanced team management",
        ControlUserPermissions: "Control user permissions and access levels",
        PlatinumFeatures: "Platinum features",
        AccessAllPlatinumTools: "Access all platinum tools and capabilities",
        UnlockPremium: "Unlock Premium",
        CalendarUpgradePremiumDescription: "Upgrade to Premium for your team. Plan recurring events, organize them and share your calendar.",
        CalendarPremiumRecurrence: "Recurring events",
        CalendarPremiumRecurrenceDescription: "Repeat your events daily, weekly or monthly",
        CalendarPremiumOrganize: "Tags and emoji",
        CalendarPremiumOrganizeDescription: "Organize and highlight your events",
        CalendarPremiumShare: "Share and print",
        CalendarPremiumShareDescription: "Share your events and print your calendar",
        PrioritySupport: "Priority support",
        DedicatedAssistance: "Dedicated assistance",
        LearnMoreFeatures: "Learn more about features",
        UnlockPremiumFeatures: "Unlock Premium to enable more features",
        UpgradePremium: "Upgrade Premium",
        UpgradePlatinum: "Upgrade Platinum",
        Cancel: "Cancel",
        Insert: "Insert",
        ThanksPurchase: "Thank you for your purchase",
        PremiumNowAvailable: "You can now enjoy all the premium features",
        ManageLicences: "Manage licences",
        Close: "Close",
        RequestAccess: "Request Access",
        UpgradeTeamMessage: "Upgrade to Premium for your own team. You will be able to manage the members who will have access to the Premium version.",
        UpgradePlatinumTeamMessage: "Upgrade to Platinum for your own team. You will be able to manage the members who will have access to the Platinum version.",
        TeamHasLicences: "Your company already upgraded to Premium. Leave a message to the administrator to request access.",
        NoPremiumAccess: "You do not have Premium access",
        TeamHasPlatinumLicences: "Your company already upgraded to Platinum. Leave a message to the administrator to request access.",
        NoPlatinumAccess: "You do not have Platinum access",
        RequestAccessMessage: "Leave a message to the administrator to request access. It will be notified and will grant access soon.",
        Send: "Send",
        AdministratorNotified: "The administrator has been notified. You will get an email when it is done.",
        DefaultRequestMessage: "Hey, I am {userName} and I would like to have Premium access on {appTitle}. Thank you.",
        RequestAccessInApprobation: "An access request is being approved. If you are in a hurry, activate Premium now",
        "RequestAccess:Title": "Request access to {appTitle}",
        "RequestAccess:Subtitle": "Your organization already subscribes to this app: an administrator only needs to assign you a licence.",
        "RequestAccess:Step1": "Your administrators receive your request by email",
        "RequestAccess:Step2": "One of them assigns you a licence",
        "RequestAccess:Step3": "You receive an email as soon as your access is active",
        "RequestAccess:MessageLabel": "Message to your administrators",
        "RequestAccess:Send": "Send request",
        "RequestAccess:Pending": "You already have a request awaiting approval. You will receive an email as soon as an administrator responds.",
        "RequestAccess:Failed": "Your request could not be sent. Please try again in a moment.",
        SendMessage: "Send message",
        Call: "Call",
        System: "System",
        Unknown: "Unknown",
        TokenExpired: "Token expired",
        PleaseRefreshTab: "Please refresh tab",
        AnErrorOccured: "An error occured",
        Consent: "Consent",
        NeedToConsent: "Need to consent",
        ClickButtonToContinue: "Click button to continue",
        SearchATeam: "Search a team",
        JoinTeam: "Join team",
        Teams: "Teams",
        EditTextConfirm: "Save",
        EditTextEdit: "Edit",
        EditTextRemove: "Remove",
        EditTextLink: "Link",
        "Permissions:Title": "Permissions",
        "Page:Back": "Back",
        "Premium:LicenceHint": "Good news: your organisation already has {appTitle} licences. Ask your admin to assign you one.",
        "Premium:RequestLicence": "Request a licence from my admin",
        "AdminLicence:Badge": "Administrator",
        "AdminLicence:Title": "Assign yourself a {plan} licence",
        "AdminLicence:Subtitle": "Your organisation already has {appTitle} licences available. As an administrator, you can take one in a few clicks, with no purchase needed.",
        "AdminLicence:Hint": "From the same page, you can also assign licences to your colleagues.",
        "AdminLicence:Assign": "Assign me a licence",
        "Page:UpgradeCta": "Upgrade",
        "SaveBar:Unsaved": "You have unsaved changes",
        "SaveBar:Discard": "Discard",
        "SaveBar:Save": "Save changes",
        "SaveBar:Saved": "Changes saved.",
        "SaveBar:Failed": "Your changes couldn't be saved. Try again.",
        "Permissions:Subtitle": "Choose who can add, change and delete {taskName}.",
        "Permissions:ModeTitle": "Who can make changes",
        "Permissions:ModeEveryoneTitle": "Everyone",
        "Permissions:ModeEveryoneBody": "Every member of the channel can add, change and delete {taskName}.",
        "Permissions:ModeOwnersTitle": "Owners only",
        "Permissions:ModeOwnersBody": "Members see {taskName}; only the owners of {appTitle} can change them.",
        "Permissions:ModeCustomTitle": "Custom",
        "Permissions:ModeCustomBody": "Choose, member by member, who can add, change and delete {taskName}.",
        "Permissions:CustomHint": "Choose Custom to set the rights of each member.",
        "Permissions:ReadOnly": "Only owners can change permissions. You can see them here.",
        "Permissions:UpgradeTitle": "Custom permissions come with Platinum",
        "Permissions:UpgradeBody": "Decide member by member who can add, change and delete {taskName}.",
        "Permissions:LicencePremium": "Premium",
        "Permissions:LicenceFree": "Free",
        "Permissions:MakeOwner": "Make owner",
        "Permissions:You": "You",
        "Permissions:Loading": "Loading members…",
        "Permissions:NoMatch": "No member matches “{search}”.",
        "Permissions:NoMembers": "No members yet",
        "Permissions:NoMembersBody": "Add members to give them their own rights.",
        "Permissions:PageInfo": "{from}–{to} of {total}",
        "Permissions:PreviousPage": "Previous page",
        "Permissions:NextPage": "Next page",
        "Permissions:MembersTitle": "Members ({count})",
        "Permissions:AddMembers": "Add members",
        "Permissions:LockedWhileDirty": "Save or discard your changes to search or change page.",
        "Sync:Subtitle": "See your Outlook, Google or other calendars in {app}, and follow {app} from other calendar apps.",
        "Sync:SubtitleResource": "Follow {app} from Outlook, Google Calendar or any other calendar app.",
        "Sync:ExternalTitle": "External calendars ({count}/{max})",
        "Sync:ExternalHint": "Refreshed every 15 minutes. Only you see them, unless you share them.",
        "Sync:MaxReached": "You can synchronize up to {max} calendars.",
        "Sync:EmptyTitle": "No external calendar yet",
        "Sync:EmptyBody": "Paste the .ics link of an Outlook or Google calendar to see its events in {app}.",
        "Sync:NewCalendar": "new calendar",
        "Sync:NameLabel": "Name",
        "Sync:NamePlaceholder": "E.g. Team holidays",
        "Sync:UrlLabel": ".ics link",
        "Sync:UrlPlaceholder": "https://…/calendar.ics",
        "Sync:UrlHelp": "Starts with https:// and ends with .ics",
        "Sync:ColorLabel": "Colour",
        "Sync:StatusNew": "Not saved yet",
        "Sync:StatusChecking": "Checking…",
        "Sync:StatusIssue": "Connection issue",
        "Sync:ShareToggle": "Show it to the other members of {app}",
        "Sync:Remove": "Remove",
        "Sync:RemoveConfirm": "Remove “{name}”? Its events will disappear from your view.",
        "Sync:PublishTitle": "Follow {app} from another app",
        "Sync:PublishBody": "Subscribe to this address from Outlook, Google Calendar or any app that reads the iCal format. Keep it private: anyone with the link can see your events.",
        "Sync:PublishLocked": "Available with Platinum",
        "Sync:Copy": "Copy link",
        "Sync:Copied": "Copied",
        "Sync:FixErrors": "Complete the highlighted fields to save.",
        "Sync:UpgradeTitle": "Calendar sync comes with Platinum",
        "Sync:UpgradeBody": "Bring up to 3 external calendars into {app} and follow it from other calendar apps.",
        "Permissions:Search": "Search for members",
        "Permissions:TableName": "Name",
        "Permissions:TableRole": "Role",
        "Reminds:Permissions:Tableadd": "Add",
        "Reminds:Permissions:Tableupdate": "Modify",
        "Reminds:Permissions:Tabledelete": "Delete",
        "Calendar:Permissions:Tableadd": "Add",
        "AiCalendar:Permissions:Tableadd": "Add",
        "Calendar:Permissions:Tableupdate": "Modify",
        "AiCalendar:Permissions:Tableupdate": "Modify",
        "Calendar:Permissions:Tabledelete": "Delete",
        "AiCalendar:Permissions:Tabledelete": "Delete",
        "Calendar:Permissions:TableallowShareSynchro": "Calendar Sharing",
        "AiCalendar:Permissions:TableallowShareSynchro": "Calendar Sharing",
        "Calendar:Permissions:TableallowEditMeetingScheduler": "Meeting Scheduler",
        "Booking:Permissions:Tableadd": "Add",
        "Booking:Permissions:Tableupdate": "Modify",
        "Booking:Permissions:Tabledelete": "Delete",
        "Parking:Permissions:Tableadd": "Add",
        "Parking:Permissions:Tableupdate": "Modify",
        "Parking:Permissions:Tabledelete": "Delete",
        "Contact:Permissions:Tableadd": "Add",
        "Contact:Permissions:Tableupdate": "Modify",
        "Contact:Permissions:Tabledelete": "Delete",
        "Keepass:Permissions:Tableadd": "Add",
        "Keepass:Permissions:Tableupdate": "Modify",
        "Keepass:Permissions:Tabledelete": "Delete / Retrieve",
        "Permissions:CancelButton": "Cancel",
        "Permissions:SaveButton": "Save",
        "Permissions:AddMemberButton": "Add member",
        "Permissions:GeneralSetting": "Default permissions",
        "Reminds:Permissions:addInfo": "User will be able to add reminds",
        "Reminds:Permissions:updateInfo": "User will be able to modify reminds",
        "Reminds:Permissions:deleteInfo": "User will be able to delete reminds",
        "Calendar:Permissions:addInfo": "User will be able to add events",
        "AiCalendar:Permissions:addInfo": "User will be able to add events",
        "Calendar:Permissions:updateInfo": "User will be able to modify events",
        "AiCalendar:Permissions:updateInfo": "User will be able to modify events",
        "Calendar:Permissions:deleteInfo": "User will be able to delete events",
        "AiCalendar:Permissions:deleteInfo": "User will be able to delete events",
        "Calendar:Permissions:allowEditMeetingSchedulerInfo": "The user will be able to manage meeting scheduler settings",
        "Calendar:Permissions:allowShareSynchroInfo": "User will be able to share his synchronized calendars with everyone",
        "AiCalendar:Permissions:allowShareSynchroInfo": "User will be able to share his synchronized calendars with everyone",
        "Booking:Permissions:addInfo": "User will be able to add booking",
        "Booking:Permissions:updateInfo": "User will be able to modify booking",
        "Booking:Permissions:deleteInfo": "User will be able to delete booking",
        "Parking:Permissions:addInfo": "User will be able to add booking",
        "Parking:Permissions:updateInfo": "User will be able to modify booking",
        "Parking:Permissions:deleteInfo": "User will be able to delete booking",
        "Contact:Permissions:addInfo": "The user will be able to add contacts and groups",
        "Contact:Permissions:updateInfo": "The user will be able to modify contacts and groups",
        "Contact:Permissions:deleteInfo": "The user will be able to delete contacts and groups",
        "Keepass:Permissions:addInfo": "User will be able to add password",
        "Keepass:Permissions:updateInfo": "User will be able to modify password",
        "Keepass:Permissions:deleteInfo": "User will be able to delete and retrieve password",
        "Permissions:Owner": "Owner",
        "Permissions:Admin": "Administrator",
        "Permissions:Member": "Member",
        "Permissions:MemberIsNotPlatinum": "Customization exclusive to Platinum subscribers",
        "Permissions:EveryoneDropdown": "Everybody in this channel can add/edit/delete {taskName}",
        "Permissions:CreatorDropdown": "Only the owner(s) of this {appTitle} can add/edit/delete {taskName}",
        "Permissions:CustomDropdown": "Customize permissions",
        "Permissions:Platinum": "Platinum",
        "Permissions:Premium": "<a href='https://admin.teams-pro.com/users' target='_blank'>Premium</a>",
        "Permissions:Free": "<a href='https://admin.teams-pro.com/users' target='_blank'>Free</a>",
        "Permissions:AssignLicense": "Click to assign a Platinum license 🚀",
        "Permissions:Subscription": "Subscription",
        "Booking:taskName": "bookings",
        "Parking:taskName": "bookings",
        "Calendar:taskName": "events",
        "AiCalendar:taskName": "events",
        "Reminds:taskName": "reminders",
        "Keepass:taskName": "passwords",
        "Contact:taskName": "contacts and groups",
        "Gantt:taskName": "tasks",
        AddMembers: "Add members",
        AddMembersTagLine: "Start typing the email address of the person you wish to add",
        EmailAddress: "Enter email address",
        SaveAlert: "Your modifications have been successfully saved!",
        CancelTagLine: "If you proceed now, any changes you've made will be discarded. Are you sure you want to continue?",
        Continue: "Continue",
        Return: "Return",
        "Permissions:FreeRedirect": "You're using a free version of {appTitle}.",
        "Permissions:PremiumRedirect": "You're using a premium version of {appTitle}.",
        "Sync:PremiumRedirect": "You're using a premium version of {appTitle}. Upgrade to Platinum 🚀 and manage synchronizations!",
        "Sync:FreeRedirect": "You're using a free version of {appTitle}. Upgrade to Platinum 🚀 and manage synchronizations!",
        NotAllowed: "You are not allowed to change the permissions.",
        NotAllowedNotif: "You are not allowed to change this settings.",
        CancelModifications: "Cancel modifications",
        "Sync:Title": "Synchronize calendars",
        "Sync:Manage": "Manage",
        "Sync:Synchronize": "Synchronize",
        "Sync:Add": "Add a calendar",
        "Sync:SyncCalendarTitle": "Synchronize calendars to my ",
        "Sync:ShareTitle": "Share my ",
        "Sync:CalendarName": "Name of the calendar",
        "Sync:ICSLink": ".ICS link of the calendar",
        "Sync:PublicAddress": "Public address iCal format",
        "Sync:TableName": "Name",
        "Sync:TableColor": "Color",
        "Sync:TableShow": "Share",
        "Sync:TableState": "State",
        "Sync:SynchronizeLine": "To handle all your calendars in one place, synchronize your calendar.",
        "Sync:SyncCalendarTooltip": " You can synchronize maximum 3 calendars. Your calendar will be synchronized every 15 minutes.",
        "Sync:SyncTitle": "Add external calendar",
        AddAlert: "The member(s) have been successfully added",
        "Sync:ICSInput": "Type an url",
        "Sync:NameInput": "Type a name",
        "Sync:TableAction": "Action",
        "Sync:ManageTooltip": "You do not have a single synchronized calendar",
        AddressTitle: "Address",
        AddAddress: "Type here to search an address",
        Participants: "Participants",
        NoParticipants: "No result found",
        "Sync:TabTooltip": "You have to save/cancel your changes",
        "Sync:DeleteCalendar": "Delete calendar",
        "Sync:DeleteTagLine": "If you proceed now, your calendar will be deleted from your view. To see it again, you will have to synchronize it again.",
        "Sync:NotAllowToShare": "The owner(s) of the Calendar did not allow you to share your calendars with others",
        "Sync:ConnectionIssue": "Problème de connexion au calendrier détecté. Vérifiez l'existence du calendrier et l'état de la connexion pour une synchronisation fluide.",
        "Permissions:CreatorRole": "Owner of this calendar",
        Synchronized: "Synchronized",
        Unsynchronized: "Unsynchronized",
        "Sync:UnsynchronizedTooltip": "Calendar connection issue detected. Verify calendar existence and connection status for seamless synchronization",
        "Sync:ShareInfo": "Share this calendar with members on ",
        AddParticipantsButton: "Add participants",
        "Sync:getErrorMessage": "An error with your ICS link occurred on the calendar : ",
        "Permissions:ManageRoleTitle": "Role Change Confirmation",
        "Permissions:ManageRoleTagLine": "You are about to change the role of a member in your tab. By proceeding, you will grant rights that you won't be able to revoke from a member. Are you sure you want to continue?",
        NotifDialogHeader: "Teams notification settings",
        RedirectToAppSource: "<p style='text-align: center;'>We're bringing you to the Microsoft Marketplace. If you're not redirected, <a target='_blank' href='{link}'>click here</a>.</p>",
        WhatsNewsOn: "What's new?",
        NewsSoon: "News will come soon!",
        NeedConsentTitle: "Need consent",
        NeedConsent: "To perform this action we will need consent. If you confirm you will be redirect to the consent page.",
        NoAddress: "No result found on Google Maps",
        YourInfo: "Your info",
        ChooseTime: "Choose a date and time",
        IC_SuperAdminTitle: "Warning",
        IC_SuperAdminExpiredCardMessage: "Your payment information expires soon, please update it to avoid service disruption.",
        IC_SuperAdminPaymentDueMessage: "Your account has outstanding invoices. Please settle them to avoid service disruption.",
        IC_SuperAdminCTA: "Go to Admin Center.",
        IC_AdminTitle: "Warning",
        IC_AdminExpiredCardMessage: "Your associated licence's payment method is about to expire.",
        IC_AdminPaymentDueMessage: "We couldn’t process the payment for your license, to avoid service disruption",
        IC_AdminExpiredCardCTA: "Click here to inform your Super Admin.",
        IC_AdminPaymentDueCTA: "click here to notify your Super Admin.",
        IC_NotifTitle: "Attention needed",
        IC_NotifMessage: "Please access {appName} for important updates",
        IC_SuccesNotifTitle: "Success",
        IC_SuccesNotifMessage: "Notification has been successfully sent to your Super Admin.",
        PreventUnlockPremiumFeaturesOnMobile: "To upgrade to the Premium/Platinum version, please use Teams desktop or web.",
        GoToAdminCenter: "Go to Admin Center",
        PremiumMessage1: "You're using a premium version of {appTitle}.",
        ClickHere: "Click here 🚀",
        PremiumMessage2: "to upgrade to Platinum and manage permissions more effectively!",
        DiscardMessageTitle: "Unsaved changes",
        DiscardChanges: "Discard",
        ContinueEditing: "Continue editing",
        DiscardMessage: "Do you want to discard edits or continue editing?",
        VisitLink: "Visit the link",
        SelectCustomize: "To customize permissions, select 'Customize permissions' above",
        SaveBeforeSearch: "Save your modifications before searching",
        AccessMaster: "This user will have access to master password",
        FeaturesNowAvailable: "Enjoy all your new features now!",
        KnowAboutFeatures: "To learn more about the features available to you, click <a target='_blank' href='{link}'>here</a>!",
        Go: "Let's go!",
        NeedToBuyLicences: "You need to buy licences",
        HaveLicencesButNotEnough: "You already have some licences but they are all assigned. You have to buy more licences to assign one to yourself.",
        BuyMoreLicence: "Buy more licences",
        GeneralPermissionsSettings: "General permissions settings",
        CustomizedPermissionsSettings: "Customized permissions settings",
        About: "About",
        ReviewTitleJoin: "Join thousands of users who love {appName}!",
        ReviewSubtitleShare: "Help others discover the app by sharing your experience",
        ReviewQuote: "The best apps are born from user feedback",
        ThanksForYourRating: "Thanks for your rating",
        ReviewFeedbackQuestion: "We'd love your feedback! It only takes two minutes.",
        WhatCouldWeImprove: "What could we improve? 💭",
        SubmitMyFeedback: "Submit my feedback",
        FillCompleteFeedbackForm: "Fill out our complete feedback form",
        MaybeLater: "Maybe later",
        ReviewOnAppSource: "Review on AppSource",
        Version: "Version",
        UniqueID: "Unique identifier",
        Copied: "Copied!",
        Copy: "Copy",
        CreatedBy: "Created by",
        SuggestFeature: "Suggest a Feature",
        HelpCenter: "Help Center",
        MoreApps: "More Apps",
        "Sync:NoUrlErrorMessage": "Please fill this input with a valid ics link",
        "Sync:NoNameErrorMessage": "Please add a name to this calendar",
        "Sync:StartUrlErrorMessage": 'Please enter a valid ics link, it should start by a "https://"',
        "Sync:EndUrlErrorMessage": 'Please enter a valid ics link, it should end by a ".ics"',
        no_reason: "I no longer need the app",
        technical_issue: "Technical issues or bugs",
        bad_interface: "Difficult to use or understand",
        limited_features: "Limited features or functionality",
        switching_to_another_app: "Switching to a nother solution ",
        temporary_uninstallation: "Temporary uninstallation (I might return)",
        UninstallReason: "Reason",
        UninstallComment: "Comment",
        "Rte:StartUrlErrorMessage": 'Please enter a valid link, it should start by a "https://"',
        "Rte:InsertLink": "Insert link",
        "Rte:TextToDisplay": "Text to display",
        "Rte:Address": "Address",
        "Rte:AddressPlaceholder": "Link to an existing web page",
        "Rte:NoHighlight": "No highlight",
        "Rte:ByDefault": "By default",
        "Rte:Large": "Large",
        "Rte:Medium": "Medium",
        "Rte:InsertImageLink": "Insert image link",
        "Rte:ImageAddressPlaceholder": "Link to an existing image on the web",
        "CookieDialogAnswer": "Make {appName} Your Best Tool",
        "Experience": "Improve my experience:",
        "ExperienceDesc": "Optimize performance, fix bugs faster, and prioritize the features you use most.",
        "Offer": "Receive personalized offers:",
        "OfferDesc": "Tips, updates, and promotions tailored to your usage. No spam. You can unsubscribe anytime.",
        "AcceptAll": "Accept All",
        "Consent_Title": "Get more out of {appName} ✨",
        "Consent_Subtitle": "Product tips & offers by email, plus usage insights that help us improve {appName}. Optional and off by default. Change anytime.",
        "Consent_Footer": "These choices never touch your data in {appName}. What you create in the app is not shared and is never used for marketing.",
        "Consent_TrustRow": "From Witivio · a Microsoft partner · Unsubscribe anytime",
        "Consent_Marketing": "Email me tips & offers",
        "Consent_MarketingDesc": "About once a month: product tips, updates and offers. Unsubscribe in one click, anytime.",
        "Consent_Experience": "Help improve {appName}",
        "Consent_ExperienceDesc": "Share how you use {appName} so we fix bugs faster and build the features you use most. Never the content you create in the app.",
        "Consent_EnableAll": "Accept all ✨",
        "Consent_Customize": "Customize",
        "Consent_Save": "Save my choices",
        "Consent_Cancel": "Cancel",
        "Consent_Saved": "Saved ✅ Here's what you turned on:",
        "Consent_Declined": "All set. Nothing is shared.",
        "Consent_ResultMarketing": "• Tips & offers by email",
        "Consent_ResultExperience": "• Product-improvement insights",
        "Consent_ManageHint": "Change these anytime from the toolbar menu: Privacy choices.",
        "Consent_PrivacyMenu": "Privacy choices",
        "ConsentScreen_Title": "One last step before you start",
        "ConsentScreen_Subtitle": "This app works with your Microsoft 365 account. Allow access once and you're all set.",
        "ConsentScreen_Allow": "Allow access",
        "ConsentScreen_Waiting": "Waiting for Microsoft…",
        "ConsentScreen_Finishing": "Setting things up…",
        "ConsentScreen_TryAgain": "Try again",
        "ConsentScreen_Hint": "A Microsoft window opens to confirm. Your password is never shared with the app.",
        "ConsentScreen_Revoke": "You can remove this access at any time from {link}.",
        "ConsentScreen_FailedTitle": "Access wasn't granted",
        "ConsentScreen_FailedText": "The Microsoft window closed before access was allowed. If it said \"Need admin approval\", only an IT admin can approve this app: send them the link below.",
        "ConsentScreen_AdminToggle": "Need admin approval?",
        "ConsentScreen_AdminText": "Send this link to your IT admin. Once they approve it, access is granted for everyone in your organization.",
        "ConsentScreen_CopyLink": "Copy link",
        "ConsentScreen_Copied": "Link copied",
        "ConsentScreen_LinkLabel": "Admin approval link",
        "OnboardingTour:MenuEntry": "Guided tour",
        "OnboardingTour:HowToUse": "How to use it",
        "OnboardingTour:Step": "{current} of {total}",
        "OnboardingTour:Start": "Start the tour",
        "OnboardingTour:Next": "Next",
        "OnboardingTour:Back": "Back",
        "OnboardingTour:Skip": "Skip",
        "OnboardingTour:Done": "Got it",
    },
    fr: {
        SendMessage: "Envoyer un message",
        Call: "Appeler",
        System: "Système",
        Unknown: "Inconnu",
        TokenExpired: "Token expiré",
        PleaseRefreshTab: "Veuillez rafraîchir l'onglet",
        AnErrorOccured: "Une erreur est survenue",
        Consent: "Consentir",
        NeedToConsent: "Vous devez donner votre accord",
        ClickButtonToContinue: "Cliquez sur le bouton pour continuer",
        SearchATeam: "Rechercher une équipe",
        JoinTeam: "Rejoindre l'équipe",
        Teams: "Équipes",
        EditTextConfirm: "Sauvegarder",
        EditTextEdit: "Edit",
        EditTextRemove: "Supprimer",
        EditTextLink: "Link",
        UnlockPremiumFeatures: "Accédez au Premium pour obtenir plus de fonctionnalités",
        UpgradePremium: "Activer Premium",
        UpgradePlatinum: "Activer Platinum",
        Cancel: "Annuler",
        Insert: "Insérer",
        ThanksPurchase: "Merci pour votre achat",
        PremiumNowAvailable: "Vous pouvez dès à présent profiter de toutes les fonctionnalités premium",
        ManageLicences: "Gérer les licences",
        Close: "Fermer",
        RequestAccess: "Demander un accès",
        UpgradeTeamMessage: "Activez la version Premium pour votre équipe. Vous aurez la possibilité de gérer les membres qui auront accès à la version Premium.",
        UpgradePlatinumTeamMessage: "Activez la version Platinum pour votre équipe. Vous aurez la possibilité de gérer les membres qui auront accès à la version Platinum.",
        TeamHasLicences: "Votre entreprise a déjà accès à la version Premium. Envoyez un message à l'administrateur pour demander un accès.",
        NoPremiumAccess: "Vous n'avez pas d'accès Premium",
        TeamHasPlatinumLicences: "Votre entreprise a déjà accès à la version Platinum. Envoyez un message à l'administrateur pour demander un accès.",
        NoPlatinumAccess: "Vous n'avez pas d'accès Platinum",
        RequestAccessMessage: "Laissez un message à l'administrateur pour votre demande d'accès. Il sera notifié et vous donnera un accès sous peu.",
        Send: "Envoyer",
        AdministratorNotified: "L'administrateur a été notifié. Vous recevrez un email lorsque votre demande aura été validé.",
        DefaultRequestMessage: "Bonjour, je suis {userName} et je souhaiterai avoir accès à la version Premium de {appTitle}. Merci.",
        RequestAccessInApprobation: "Une demande d’accès est en cours d’approbation. Si vous êtes pressé, activez le Premium maintenant",
        "RequestAccess:Title": "Demander l'accès à {appTitle}",
        "RequestAccess:Subtitle": "Votre organisation est déjà abonnée à cette application : un administrateur n'a plus qu'à vous attribuer une licence.",
        "RequestAccess:Step1": "Vos administrateurs reçoivent votre demande par e-mail",
        "RequestAccess:Step2": "L'un d'eux vous attribue une licence",
        "RequestAccess:Step3": "Vous recevez un e-mail dès que votre accès est actif",
        "RequestAccess:MessageLabel": "Message à vos administrateurs",
        "RequestAccess:Send": "Envoyer la demande",
        "RequestAccess:Pending": "Vous avez déjà une demande en attente d'approbation. Vous recevrez un e-mail dès qu'un administrateur y aura répondu.",
        "RequestAccess:Failed": "Votre demande n'a pas pu être envoyée. Réessayez dans un instant.",
        "Permissions:Title": "Permissions",
        "Page:Back": "Retour",
        "Premium:LicenceHint": "Bonne nouvelle : votre organisation a déjà des licences {appTitle}. Demandez à votre administrateur de vous en attribuer une.",
        "Premium:RequestLicence": "Demander une licence à mon administrateur",
        "AdminLicence:Badge": "Administrateur",
        "AdminLicence:Title": "Attribuez-vous une licence {plan}",
        "AdminLicence:Subtitle": "Votre organisation dispose déjà de licences {appTitle}. En tant qu'administrateur, vous pouvez vous en attribuer une en quelques clics, sans achat supplémentaire.",
        "AdminLicence:Hint": "Depuis la même page, vous pouvez aussi attribuer des licences à vos collègues.",
        "AdminLicence:Assign": "M'attribuer une licence",
        "Page:UpgradeCta": "Passer à l'offre supérieure",
        "SaveBar:Unsaved": "Vous avez des modifications non enregistrées",
        "SaveBar:Discard": "Annuler les modifications",
        "SaveBar:Save": "Enregistrer",
        "SaveBar:Saved": "Modifications enregistrées.",
        "SaveBar:Failed": "Vos modifications n'ont pas pu être enregistrées. Réessayez.",
        "Permissions:Subtitle": "Choisissez qui peut ajouter, modifier et supprimer des {taskName}.",
        "Permissions:ModeTitle": "Qui peut faire des modifications",
        "Permissions:ModeEveryoneTitle": "Tout le monde",
        "Permissions:ModeEveryoneBody": "Chaque membre du canal peut ajouter, modifier et supprimer des {taskName}.",
        "Permissions:ModeOwnersTitle": "Propriétaires uniquement",
        "Permissions:ModeOwnersBody": "Les membres voient les {taskName} ; seuls les propriétaires de {appTitle} peuvent les modifier.",
        "Permissions:ModeCustomTitle": "Personnalisé",
        "Permissions:ModeCustomBody": "Choisissez, membre par membre, qui peut ajouter, modifier et supprimer des {taskName}.",
        "Permissions:CustomHint": "Choisissez Personnalisé pour régler les droits de chaque membre.",
        "Permissions:ReadOnly": "Seuls les propriétaires peuvent modifier les permissions. Vous pouvez les consulter ici.",
        "Permissions:UpgradeTitle": "Les permissions personnalisées sont incluses dans Platinum",
        "Permissions:UpgradeBody": "Décidez membre par membre qui peut ajouter, modifier et supprimer des {taskName}.",
        "Permissions:LicencePremium": "Premium",
        "Permissions:LicenceFree": "Gratuit",
        "Permissions:MakeOwner": "Nommer propriétaire",
        "Permissions:You": "Vous",
        "Permissions:Loading": "Chargement des membres…",
        "Permissions:NoMatch": "Aucun membre ne correspond à « {search} ».",
        "Permissions:NoMembers": "Aucun membre pour l'instant",
        "Permissions:NoMembersBody": "Ajoutez des membres pour leur donner leurs propres droits.",
        "Permissions:PageInfo": "{from}–{to} sur {total}",
        "Permissions:PreviousPage": "Page précédente",
        "Permissions:NextPage": "Page suivante",
        "Permissions:MembersTitle": "Membres ({count})",
        "Permissions:AddMembers": "Ajouter des membres",
        "Permissions:LockedWhileDirty": "Enregistrez ou annulez vos modifications pour rechercher ou changer de page.",
        "Sync:Subtitle": "Affichez vos calendriers Outlook, Google ou autres dans {app}, et suivez {app} depuis d'autres applications de calendrier.",
        "Sync:SubtitleResource": "Suivez {app} depuis Outlook, Google Agenda ou toute autre application de calendrier.",
        "Sync:ExternalTitle": "Calendriers externes ({count}/{max})",
        "Sync:ExternalHint": "Actualisés toutes les 15 minutes. Vous seul les voyez, sauf si vous les partagez.",
        "Sync:MaxReached": "Vous pouvez synchroniser jusqu'à {max} calendriers.",
        "Sync:EmptyTitle": "Aucun calendrier externe pour l'instant",
        "Sync:EmptyBody": "Collez le lien .ics d'un calendrier Outlook ou Google pour voir ses événements dans {app}.",
        "Sync:NewCalendar": "nouveau calendrier",
        "Sync:NameLabel": "Nom",
        "Sync:NamePlaceholder": "Ex. : Congés de l'équipe",
        "Sync:UrlLabel": "Lien .ics",
        "Sync:UrlPlaceholder": "https://…/calendar.ics",
        "Sync:UrlHelp": "Commence par https:// et se termine par .ics",
        "Sync:ColorLabel": "Couleur",
        "Sync:StatusNew": "Pas encore enregistré",
        "Sync:StatusChecking": "Vérification…",
        "Sync:StatusIssue": "Problème de connexion",
        "Sync:ShareToggle": "L'afficher aux autres membres de {app}",
        "Sync:Remove": "Retirer",
        "Sync:RemoveConfirm": "Retirer « {name} » ? Ses événements disparaîtront de votre vue.",
        "Sync:PublishTitle": "Suivre {app} depuis une autre application",
        "Sync:PublishBody": "Abonnez-vous à cette adresse depuis Outlook, Google Agenda ou toute application qui lit le format iCal. Gardez-la privée : toute personne qui a le lien voit vos événements.",
        "Sync:PublishLocked": "Disponible avec Platinum",
        "Sync:Copy": "Copier le lien",
        "Sync:Copied": "Copié",
        "Sync:FixErrors": "Complétez les champs signalés pour enregistrer.",
        "Sync:UpgradeTitle": "La synchronisation de calendriers est incluse dans Platinum",
        "Sync:UpgradeBody": "Ajoutez jusqu'à 3 calendriers externes dans {app} et suivez-le depuis d'autres applications de calendrier.",
        "Permissions:Search": "Rechercher des membres",
        "Permissions:TableName": "Nom",
        "Permissions:TableRole": "Rôle",
        "Reminds:Permissions:Tableadd": "Ajouter",
        "Reminds:Permissions:Tableupdate": "Modifier",
        "Reminds:Permissions:Tabledelete": "Supprimer",
        "Calendar:Permissions:Tableadd": "Ajouter",
        "AiCalendar:Permissions:Tableadd": "Ajouter",
        "Calendar:Permissions:Tableupdate": "Modifier",
        "AiCalendar:Permissions:Tableupdate": "Modifier",
        "Calendar:Permissions:Tabledelete": "Supprimer",
        "AiCalendar:Permissions:Tabledelete": "Supprimer",
        "Calendar:Permissions:TableallowShareSynchro": "Partage de calendrier",
        "AiCalendar:Permissions:TableallowShareSynchro": "Partage de calendrier",
        "Calendar:Permissions:TableallowEditMeetingScheduler": "Plateforme de rendez-vous",
        "Booking:Permissions:Tableadd": "Ajouter",
        "Booking:Permissions:Tableupdate": "Modifier",
        "Booking:Permissions:Tabledelete": "Supprimer",
        "Parking:Permissions:Tableadd": "Ajouter",
        "Parking:Permissions:Tableupdate": "Modifier",
        "Parking:Permissions:Tabledelete": "Supprimer",
        "Contact:Permissions:Tableadd": "Ajouter",
        "Contact:Permissions:Tableupdate": "Modifier",
        "Contact:Permissions:Tabledelete": "Supprimer",
        "Keepass:Permissions:Tableadd": "Ajouter",
        "Keepass:Permissions:Tableupdate": "Modifier",
        "Keepass:Permissions:Tabledelete": "Supprimer / Récupérer",
        "Permissions:CancelButton": "Annuler",
        "Permissions:SaveButton": "Sauvegarder",
        "Permissions:AddMemberButton": "Ajouter un membre",
        "Permissions:GeneralSetting": "Paramètre par default",
        "Reminds:Permissions:addInfo": "L'utilisateur pourra ajouter des rappels",
        "Reminds:Permissions:updateInfo": "L'utilisateur pourra modifer des rappels",
        "Reminds:Permissions:deleteInfo": "L'utilisateur pourra supprimer des rappels",
        "Calendar:Permissions:addInfo": "L'utilisateur pourra ajouter des évènements",
        "AiCalendar:Permissions:addInfo": "L'utilisateur pourra ajouter des évènements",
        "Calendar:Permissions:updateInfo": "L'utilisateur pourra modifer des évènements",
        "AiCalendar:Permissions:updateInfo": "L'utilisateur pourra modifer des évènements",
        "Calendar:Permissions:deleteInfo": "L'utilisateur pourra supprimer des évènements",
        "AiCalendar:Permissions:deleteInfo": "L'utilisateur pourra supprimer des évènements",
        "Calendar:Permissions:allowEditMeetingSchedulerInfo": "L'utilisateur pourra gérer les paramètres de la plateforme de rendez-vous",
        "Calendar:Permissions:allowShareSynchroInfo": "L'utilisateur pourra partager ses calendriers synchronisés avec tout le monde",
        "AiCalendar:Permissions:allowShareSynchroInfo": "L'utilisateur pourra partager ses calendriers synchronisés avec tout le monde",
        "Booking:Permissions:addInfo": "L'utilisateur pourra ajouter des réservations",
        "Booking:Permissions:updateInfo": "L'utilisateur pourra modifer des réservations",
        "Booking:Permissions:deleteInfo": "L'utilisateur pourra supprimer des réservations",
        "Parking:Permissions:addInfo": "L'utilisateur pourra ajouter des réservations",
        "Parking:Permissions:updateInfo": "L'utilisateur pourra modifer des réservations",
        "Parking:Permissions:deleteInfo": "L'utilisateur pourra supprimer des réservations",
        "Contact:Permissions:addInfo": "L'utilisateur pourra ajouter des contacts et des groupes",
        "Contact:Permissions:updateInfo": "L'utilisateur pourra modifier des contacts et des groupes",
        "Contact:Permissions:deleteInfo": "L'utilisateur pourra supprimer des contacts et des groupes",
        "Keepass:Permissions:addInfo": "L'utilisateur pourra ajouter des mots de passe",
        "Keepass:Permissions:updateInfo": "L'utilisateur pourra modifier des mots de passe",
        "Keepass:Permissions:deleteInfo": "L'utilisateur pourra supprimer et restaurer des mots de passe",
        "Permissions:Owner": "Propriétaire",
        "Permissions:Admin": "Administrateur",
        "Permissions:Member": "Membre",
        "Permissions:MemberIsNotPlatinum": "Personnalisation réservée aux abonnés Platinum",
        "Permissions:EveryoneDropdown": "Tout le monde dans ce canal peut ajouter/éditer/supprimer {taskName}",
        "Permissions:CreatorDropdown": "Seul(s) le(s) propriétaire(s) de {appTitle} peut ajouter/éditer/supprimer {taskName}",
        "Permissions:CustomDropdown": "Personnaliser les autorisations",
        "Permissions:Platinum": "Platinum",
        "Permissions:Premium": "<a href='https://admin.teams-pro.com/users' target='_blank'>Premium</a>",
        "Permissions:Free": "<a href='https://admin.teams-pro.com/users' target='_blank'>Gratuite</a>",
        "Permissions:AssignLicense": "Cliquez pour assigner une licence Platinum 🚀",
        "Permissions:Subscription": "Souscription",
        AddMembers: "Ajouter des membres",
        AddMembersTagLine: "Entrer l'adresse mail de la personne que vous souhaitez ajouter",
        EmailAddress: "Entrer une adresse mail",
        SaveAlert: "Vos modifications ont été sauvegardé avec succès !",
        CancelTagLine: "Si vous continuez maintenant, toutes les modifications que vous avez apportées seront perdues. Êtes-vous sûr de vouloir continuer ?",
        Continue: "Continuer",
        Return: "Retour",
        "Permissions:FreeRedirect": "Vous utilisez une version gratuite de {appTitle}.",
        "Permissions:PremiumRedirect": "Vous utilisez une version premium de {appTitle}.",
        "Booking:taskName": "réservations",
        "Parking:taskName": "réservations",
        "Reminds:taskName": "rappels",
        "Calendar:taskName": "événements",
        "AiCalendar:taskName": "événements",
        "Contact:taskName": "contacts et groupes",
        "Gantt:taskName": "tâches",
        "Keepass:taskName": "mots de passe",
        "Sync:PremiumRedirect": "Vous utilisez une version premium de Calendar Pro. Passer à la version Platinum 🚀 et gérer les synchronisations !",
        "Sync:FreeRedirect": "Vous utilisez une version gratuite de Calendar Pro. Passer à la version Platinum 🚀 et gérer les synchronisations !",
        NotAllowed: "Vous n'êtes pas autorisé à modifier les permissions.",
        NotAllowedNotif: "Vous n'êtes pas autorisé à modifier ces paramètres.",
        CancelModifications: "Annuler les modifications",
        "Sync:Title": "Synchroniser des calendriers",
        "Sync:Manage": "Gérer",
        "Sync:Synchronize": "Synchroniser",
        "Sync:Add": "Ajouter un calendrier",
        "Sync:SyncCalendarTitle": "Synchroniser des calendriers à mon ",
        "Sync:ShareTitle": "Partager mon ",
        "Sync:CalendarName": "Nom du calendrier",
        "Sync:ICSLink": "Lien .ICS du calendrier",
        "Sync:PublicAddress": "Adresse publique au format iCal",
        "Sync:TableName": "Nom",
        "Sync:TableColor": "Couleur",
        "Sync:TableShow": "Partager",
        "Sync:TableState": "État",
        "Sync:SynchronizeLine": "Pour gérer tous vos calendriers en un seul endroit, synchronisez votre calendrier.",
        "Sync:SyncCalendarTooltip": "Vous pouvez synchroniser 3 calendriers maximum. Votre calendrier sera synchronisé toutes les 15 minutes.",
        "Sync:SyncTitle": "Ajoutez vos calendriers externes",
        AddAlert: "Le(s) membre(s) a/ont bien été ajouté",
        "Sync:ICSInput": "Entrer une url",
        "Sync:NameInput": "Entrer un nom",
        "Sync:TableAction": "Action",
        "Sync:ManageTooltip": "Vous n'avez pas de calendrier synchronisé",
        AddressTitle: "Adresse",
        AddAddress: "Saisir une adresse",
        Participants: "Participants",
        NoParticipants: "Pas de résultat",
        "Sync:TabTooltip": "Vous devez enregistrer/annuler vos changements",
        "Sync:DeleteCalendar": "Supprimer le calendrier",
        "Sync:DeleteTagLine": "Si vous continuez maintenant, votre calendrier sera supprimé de votre vue. Pour le voir à nouveau, vous devrez à nouveau le synchroniser.",
        "Sync:NotAllowToShare": "Le(s) propriétaire(s) du calendrier ne vous a pas autorisé à partager vos calendriers avec les autres utilisateurs",
        "Sync:ConnectionIssue": "Calendar connection issue detected. Verify calendar existence and connection status for seamless synchronization",
        "Permissions:CreatorRole": "Propriétaire de ce calendrier",
        Synchronized: "Synchronisé",
        Unsynchronized: "Désynchronisé",
        "Sync:UnsynchronizedTooltip": "Problème de connexion au calendrier détecté. Vérifiez l'existence du calendrier et l'état de la connexion pour une synchronisation sans faille.",
        "Sync:ShareInfo": "Partager ce calendrier avec les membres de ",
        AddParticipantsButton: "Ajouter des participants",
        "Sync:getErrorMessage": "Une erreur avec votre lien ICS est survenue sur le calendrier : ",
        "Permissions:ManageRoleTitle": "Confirmation du changement de rôle",
        "Permissions:ManageRoleTagLine": "Vous êtes sur le point de modifier le rôle d'un membre. En faisant celà vous allez octroyez des droits que vous ne pourrez pas retirer à un membre. Êtes-vous sûr de vouloir continuer ?",
        NotifDialogHeader: "Paramétrage des notifications Teams",
        RedirectToAppSource: "<p style='text-align: center;'>Vous allez être redirigés vers Microsoft Marketplace, si vous n'êtes pas redirigé, <a target='_blank' href='{link}'>cliquez ici</a>.</a>",
        WhatsNewsOn: "Nouveautés",
        NewsSoon: "Des nouveautés arrivent bientôt!",
        NeedConsentTitle: "Besoin d'autorisation",
        NeedConsent: "Pour utiliser cette fonctionalité, des droits supplémentaire sont recquis. Si vous acceptez, vous serez redirigé sur la page d'autorisation.",
        NoAddress: "Pas de résultats trouvés sur Google Maps",
        YourInfo: "Vos informations",
        ChooseTime: "Choisir la date et l'heure",
        IC_SuperAdminTitle: "Attention",
        IC_SuperAdminExpiredCardMessage: "Vos informations de paiement expirent bientôt, veuillez les mettre à jour pour éviter toute interruption de service.",
        IC_SuperAdminPaymentDueMessage: "Des factures impayées sont présentes sur votre compte. Veuillez les régler afin d’éviter toute interruption de service.",
        IC_SuperAdminCTA: "Aller sur Admin Center",
        IC_AdminTitle: "Attention",
        IC_AdminExpiredCardMessage: "Le mode de paiement associé à votre licence est sur le point d’expirer.",
        IC_AdminPaymentDueMessage: "Nous n’avons pas pu traiter le paiement de votre licence, afin d’éviter toute interruption de service",
        IC_AdminExpiredCardCTA: "Cliquez ici pour informer votre Super Admin.",
        IC_AdminPaymentDueCTA: "cliquez ici pour notifier votre Super Admin.",
        IC_NotifTitle: "Attention requise",
        IC_NotifMessage: "Veuillez accéder à {appName} pour des mises à jour importantes",
        IC_SuccesNotifTitle: "Succès",
        IC_SuccesNotifMessage: "La notification a été envoyée avec succès à votre Super Admin.",
        PreventUnlockPremiumFeaturesOnMobile: "Pour passer à la version Premium/Platinum, veuillez utiliser Teams sur ordinateur ou sur le web.",
        GoToAdminCenter: "Accéder au Centre d'administration",
        PremiumMessage1: "Vous utilisez une version premium de {appTitle}.",
        ClickHere: "Cliquez ici 🚀",
        PremiumMessage2: "pour passer à Platinum et gérer les autorisations de manière plus efficace !",
        DiscardMessageTitle: "Modifications non enregistrées",
        DiscardChanges: "Ignorer",
        ContinueEditing: "Continuer l'édition",
        DiscardMessage: "Voulez-vous ignorer les modifications apportées ou continuer la modification ?",
        VisitLink: "Visiter le lien",
        SelectCustomize: "Pour personnaliser les autorisations, sélectionnez 'Personnaliser les autorisations' ci-dessus",
        SaveBeforeSearch: "Enregistrez vos modifications avant de rechercher",
        AccessMaster: "Cet utilisateur aura accès au mot de passe maître",
        FeaturesNowAvailable: "Profitez de toutes vos nouvelles fonctionnalités dès maintenant!",
        KnowAboutFeatures: "Pour en savoir plus sur les fonctionnalités disponibles pour vous, cliquez <a target='_blank' href='{link}'>ici</a>!",
        Go: "C'est parti!",
        NeedToBuyLicences: "Vous devez acheter des licences",
        HaveLicencesButNotEnough: "Vous avez déjà des licences mais elles sont toutes attribuées. Vous devez acheter plus de licences pour vous en attribuer une.",
        BuyMoreLicence: "Acheter plus de licences",
        GeneralPermissionsSettings: "Paramètres de permissions générales",
        CustomizedPermissionsSettings: "Paramètres de permissions personnalisés",
        About: "À propos",
        ReviewTitleJoin: "Rejoignez des milliers d'utilisateurs qui adorent {appName} !",
        ReviewSubtitleShare: "Aidez les autres à découvrir l'application en partageant votre expérience",
        ReviewQuote: "Les meilleures applications naissent des retours utilisateurs",
        ThanksForYourRating: "Merci pour votre note",
        ReviewFeedbackQuestion: "Votre avis compte ! Cela ne prend que deux minutes.",
        WhatCouldWeImprove: "Que pourrions-nous améliorer ? 💭",
        SubmitMyFeedback: "Envoyer mon avis",
        FillCompleteFeedbackForm: "Remplir notre formulaire de feedback complet",
        MaybeLater: "Plus tard",
        ReviewOnAppSource: "Noter sur AppSource",
        Version: "Version",
        UniqueID: "Identifiant unique",
        Copied: "Copié!",
        Copy: "Copier",
        CreatedBy: "Créé par",
        SuggestFeature: "Suggérer une fonctionnalité",
        HelpCenter: "Centre d'aide",
        MoreApps: "Plus d'applications",
        "Sync:NoUrlErrorMessage": "Veuillez remplir ce champ avec un lien ics valide",
        "Sync:NoNameErrorMessage": "Veuillez ajouter un nom à ce calendrier",
        "Sync:StartUrlErrorMessage": 'Veuillez entrer un lien ics valide, il doit commencer par "https://"',
        "Sync:EndUrlErrorMessage": 'Veuillez entrer un lien ics valide, il doit se terminer par ".ics"',
        no_reason: "Je n'ai plus besoin de l'application",
        technical_issue: "Problèmes techniques ou bugs",
        bad_interface: "Difficile à utiliser ou à comprendre",
        limited_features: "Fonctionnalités limitées ou insuffisantes",
        switching_to_another_app: "Je passe à une autre solution",
        temporary_uninstallation: "Désinstallation temporaire (je pourrais revenir)",
        UninstallReason: "Raison",
        UninstallComment: "Commentaire",
        "Rte:StartUrlErrorMessage": 'Veuillez entrer un lien valide, il doit commencer par "https://"',
        "Rte:InsertLink": "Insérer un lien",
        "Rte:TextToDisplay": "Texte à afficher",
        "Rte:Address": "Adresse",
        "Rte:AddressPlaceholder": "Lien vers une page web existante",
        "Rte:NoHighlight": "Pas de surlignage",
        "Rte:ByDefault": "Par défaut",
        "Rte:Large": "Grand",
        "Rte:Medium": "Moyen",
        "Rte:InsertImageLink": "Insérer un lien d'image",
        "Rte:ImageAddressPlaceholder": "Lien vers une image existante sur le web",
        UnlockPlatinum: "Débloquer le Platinum",
        UpgradePlatinumDescription: "Passez à Platinum pour votre équipe. Gérez les permissions utilisateurs et accédez aux fonctionnalités avancées conçues pour les administrateurs.",
        AdvancedTeamManagement: "Gestion avancée de l'équipe",
        ControlUserPermissions: "Contrôlez les permissions et niveaux d'accès des utilisateurs",
        PlatinumFeatures: "Fonctionnalités Platinum",
        AccessAllPlatinumTools: "Accédez à tous les outils et capacités Platinum",
        UnlockPremium: "Débloquer le Premium",
        CalendarUpgradePremiumDescription: "Passez à Premium pour votre équipe. Planifiez des événements récurrents, organisez-les et partagez votre calendrier.",
        CalendarPremiumRecurrence: "Événements récurrents",
        CalendarPremiumRecurrenceDescription: "Répétez vos événements chaque jour, semaine ou mois",
        CalendarPremiumOrganize: "Tags et emoji",
        CalendarPremiumOrganizeDescription: "Organisez et mettez en valeur vos événements",
        CalendarPremiumShare: "Partage et impression",
        CalendarPremiumShareDescription: "Partagez vos événements et imprimez votre calendrier",
        PrioritySupport: "Support prioritaire",
        DedicatedAssistance: "Assistance dédiée",
        LearnMoreFeatures: "En savoir plus sur les fonctionnalités",
        "CookieDialogAnswer": "Faire de {appName} votre meilleur outil",
        "Experience": "Améliorer mon expérience :",
        "ExperienceDesc": "Optimiser les performances, corriger les bugs plus rapidement et prioriser les fonctionnalités que vous utilisez le plus.",
        "Offer": "Recevoir des offres personnalisées :",
        "OfferDesc": "Conseils, mises à jour et promotions adaptées à votre utilisation. Pas de spam. Vous pouvez vous désabonner à tout moment.",
        "AcceptAll": "Tout accepter",
        "Consent_Title": "Tirez le meilleur de {appName} ✨",
        "Consent_Subtitle": "Conseils et offres produit par e-mail, plus des statistiques d'usage qui nous aident à améliorer {appName}. Facultatif et désactivé par défaut. Modifiable à tout moment.",
        "Consent_Footer": "Ces choix ne touchent jamais vos données dans {appName}. Ce que vous créez dans l'application n'est pas partagé et ne sert jamais au marketing.",
        "Consent_TrustRow": "De Witivio · partenaire Microsoft · Désabonnement à tout moment",
        "Consent_Marketing": "Recevoir conseils et offres par e-mail",
        "Consent_MarketingDesc": "Environ une fois par mois : conseils, nouveautés et offres produit. Désabonnement en un clic, à tout moment.",
        "Consent_Experience": "Aider à améliorer {appName}",
        "Consent_ExperienceDesc": "Partagez votre utilisation de {appName} pour nous aider à corriger les bugs plus vite et à prioriser les fonctionnalités que vous utilisez le plus. Jamais le contenu que vous créez dans l'application.",
        "Consent_EnableAll": "Tout accepter ✨",
        "Consent_Customize": "Personnaliser",
        "Consent_Save": "Enregistrer mes choix",
        "Consent_Cancel": "Annuler",
        "Consent_Saved": "Enregistré ✅ Voici ce que vous avez activé :",
        "Consent_Declined": "C'est noté. Rien n'est partagé.",
        "Consent_ResultMarketing": "• Conseils et offres par e-mail",
        "Consent_ResultExperience": "• Statistiques d'amélioration du produit",
        "Consent_ManageHint": "Modifiable à tout moment depuis le menu de la barre d'outils : Choix de confidentialité.",
        "Consent_PrivacyMenu": "Choix de confidentialité",
        "ConsentScreen_Title": "Une dernière étape avant de commencer",
        "ConsentScreen_Subtitle": "Cette application fonctionne avec votre compte Microsoft 365. Autorisez l'accès une seule fois, et c'est prêt.",
        "ConsentScreen_Allow": "Autoriser l'accès",
        "ConsentScreen_Waiting": "En attente de Microsoft…",
        "ConsentScreen_Finishing": "Finalisation…",
        "ConsentScreen_TryAgain": "Réessayer",
        "ConsentScreen_Hint": "Une fenêtre Microsoft s'ouvre pour confirmer. Votre mot de passe n'est jamais transmis à l'application.",
        "ConsentScreen_Revoke": "Vous pouvez retirer cet accès à tout moment depuis {link}.",
        "ConsentScreen_FailedTitle": "L'accès n'a pas été accordé",
        "ConsentScreen_FailedText": "La fenêtre Microsoft s'est fermée avant l'autorisation. Si elle indiquait « Approbation de l'administrateur requise », seul un administrateur informatique peut approuver l'application : envoyez-lui le lien ci-dessous.",
        "ConsentScreen_AdminToggle": "Approbation de l'administrateur requise ?",
        "ConsentScreen_AdminText": "Envoyez ce lien à votre administrateur informatique. Une fois approuvé, l'accès est accordé à toute votre organisation.",
        "ConsentScreen_CopyLink": "Copier le lien",
        "ConsentScreen_Copied": "Lien copié",
        "ConsentScreen_LinkLabel": "Lien d'approbation administrateur",
        "OnboardingTour:MenuEntry": "Visite guidée",
        "OnboardingTour:HowToUse": "Comment l'utiliser",
        "OnboardingTour:Step": "{current} sur {total}",
        "OnboardingTour:Start": "Commencer la visite",
        "OnboardingTour:Next": "Suivant",
        "OnboardingTour:Back": "Précédent",
        "OnboardingTour:Skip": "Passer",
        "OnboardingTour:Done": "J'ai compris",
    },
    de: {
        UnlockPremiumFeatures: "Schalte Premium frei, um mehr Funktionen zu aktivieren",
        UpgradePremium: "Premium aktualisieren",
        UpgradePlatinum: "Platinum aktualisieren",
        Cancel: "Abbrechen",
        Insert: "Einfügen",
        ThanksPurchase: "Vielen Dank für Ihren Einkauf",
        PremiumNowAvailable: "Sie können jetzt alle Premium-Funktionen nutzen",
        ManageLicences: "Lizenzen verwalten",
        Close: "Schließen",
        RequestAccess: "Zugriff anfordern",
        UpgradeTeamMessage: "Aktualisieren Sie auf Premium für Ihr eigenes Team. Sie können die Mitglieder verwalten, die Zugriff auf die Premium-Version haben werden.",
        UpgradePlatinumTeamMessage: "Aktualisieren Sie auf Platinum für Ihr eigenes Team. Sie können die Mitglieder verwalten, die Zugriff auf die Platinum-Version haben werden.",
        TeamHasLicences: "Ihr Unternehmen hat bereits auf Premium aktualisiert. Hinterlassen Sie eine Nachricht beim Administrator, um Zugriff anzufordern.",
        NoPremiumAccess: "Sie haben keinen Premium-Zugriff",
        TeamHasPlatinumLicences: "Ihr Unternehmen hat bereits auf Platinum aktualisiert. Hinterlassen Sie eine Nachricht beim Administrator, um Zugriff anzufordern.",
        NoPlatinumAccess: "Sie haben keinen Platinum-Zugriff",
        RequestAccessMessage: "Hinterlassen Sie eine Nachricht beim Administrator, um Zugriff anzufordern. Dieser wird benachrichtigt und gewährt bald Zugriff.",
        Send: "Senden",
        AdministratorNotified: "Der Administrator wurde benachrichtigt. Sie erhalten eine E-Mail, wenn dies erledigt ist.",
        DefaultRequestMessage: "Hallo, ich bin {userName} und möchte auf {appTitle} Premium-Zugriff haben. Danke.",
        RequestAccessInApprobation: "Eine Zugriffsanforderung wird genehmigt. Wenn es eilig ist, aktivieren Sie jetzt Premium",
        "RequestAccess:Title": "Zugriff auf {appTitle} anfordern",
        "RequestAccess:Subtitle": "Ihre Organisation hat diese App bereits abonniert: Ein Administrator muss Ihnen nur noch eine Lizenz zuweisen.",
        "RequestAccess:Step1": "Ihre Administratoren erhalten Ihre Anfrage per E-Mail",
        "RequestAccess:Step2": "Einer von ihnen weist Ihnen eine Lizenz zu",
        "RequestAccess:Step3": "Sie erhalten eine E-Mail, sobald Ihr Zugriff aktiv ist",
        "RequestAccess:MessageLabel": "Nachricht an Ihre Administratoren",
        "RequestAccess:Send": "Anfrage senden",
        "RequestAccess:Pending": "Sie haben bereits eine Anfrage, die auf Genehmigung wartet. Sie erhalten eine E-Mail, sobald ein Administrator antwortet.",
        "RequestAccess:Failed": "Ihre Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es gleich noch einmal.",
        SendMessage: "Nachricht senden",
        Call: "Anruf",
        System: "System",
        Unknown: "Unbekannt",
        TokenExpired: "Token abgelaufen",
        PleaseRefreshTab: "Bitte Tab neu laden",
        AnErrorOccured: "Ein Fehler ist aufgetreten",
        Consent: "Einwilligung",
        NeedToConsent: "Einwilligung erforderlich",
        ClickButtonToContinue: "Klicken Sie auf die Schaltfläche, um fortzufahren",
        SearchATeam: "Ein Team suchen",
        JoinTeam: "Team beitreten",
        Teams: "Teams",
        EditTextConfirm: "Speichern",
        EditTextEdit: "Bearbeiten",
        EditTextRemove: "Entfernen",
        EditTextLink: "Verknüpfen",
        "Permissions:Title": "Berechtigungen",
        "Page:Back": "Zurück",
        "Premium:LicenceHint": "Gute Nachricht: Ihre Organisation hat bereits {appTitle}-Lizenzen. Bitten Sie Ihren Administrator, Ihnen eine zuzuweisen.",
        "Premium:RequestLicence": "Lizenz bei meinem Administrator anfordern",
        "AdminLicence:Badge": "Administrator",
        "AdminLicence:Title": "Weisen Sie sich eine {plan}-Lizenz zu",
        "AdminLicence:Subtitle": "Ihre Organisation verfügt bereits über freie {appTitle}-Lizenzen. Als Administrator können Sie sich mit wenigen Klicks eine zuweisen, ohne zusätzlichen Kauf.",
        "AdminLicence:Hint": "Auf derselben Seite können Sie auch Ihren Kollegen Lizenzen zuweisen.",
        "AdminLicence:Assign": "Mir eine Lizenz zuweisen",
        "Page:UpgradeCta": "Upgrade",
        "SaveBar:Unsaved": "Sie haben nicht gespeicherte Änderungen",
        "SaveBar:Discard": "Verwerfen",
        "SaveBar:Save": "Änderungen speichern",
        "SaveBar:Saved": "Änderungen gespeichert.",
        "SaveBar:Failed": "Ihre Änderungen konnten nicht gespeichert werden. Versuchen Sie es erneut.",
        "Permissions:Subtitle": "Legen Sie fest, wer {taskName} hinzufügen, ändern und löschen darf.",
        "Permissions:ModeTitle": "Wer Änderungen vornehmen darf",
        "Permissions:ModeEveryoneTitle": "Alle",
        "Permissions:ModeEveryoneBody": "Jedes Mitglied des Kanals kann {taskName} hinzufügen, ändern und löschen.",
        "Permissions:ModeOwnersTitle": "Nur Besitzer",
        "Permissions:ModeOwnersBody": "Mitglieder sehen {taskName}; nur die Besitzer von {appTitle} können sie ändern.",
        "Permissions:ModeCustomTitle": "Benutzerdefiniert",
        "Permissions:ModeCustomBody": "Legen Sie für jedes Mitglied fest, wer {taskName} hinzufügen, ändern und löschen darf.",
        "Permissions:CustomHint": "Wählen Sie Benutzerdefiniert, um die Rechte jedes Mitglieds festzulegen.",
        "Permissions:ReadOnly": "Nur Besitzer können Berechtigungen ändern. Hier können Sie sie einsehen.",
        "Permissions:UpgradeTitle": "Benutzerdefinierte Berechtigungen gibt es mit Platinum",
        "Permissions:UpgradeBody": "Legen Sie für jedes Mitglied fest, wer {taskName} hinzufügen, ändern und löschen darf.",
        "Permissions:LicencePremium": "Premium",
        "Permissions:LicenceFree": "Kostenlos",
        "Permissions:MakeOwner": "Zum Besitzer machen",
        "Permissions:You": "Sie",
        "Permissions:Loading": "Mitglieder werden geladen…",
        "Permissions:NoMatch": "Kein Mitglied entspricht „{search}“.",
        "Permissions:NoMembers": "Noch keine Mitglieder",
        "Permissions:NoMembersBody": "Fügen Sie Mitglieder hinzu, um ihnen eigene Rechte zu geben.",
        "Permissions:PageInfo": "{from}–{to} von {total}",
        "Permissions:PreviousPage": "Vorherige Seite",
        "Permissions:NextPage": "Nächste Seite",
        "Permissions:MembersTitle": "Mitglieder ({count})",
        "Permissions:AddMembers": "Mitglieder hinzufügen",
        "Permissions:LockedWhileDirty": "Speichern oder verwerfen Sie Ihre Änderungen, um zu suchen oder die Seite zu wechseln.",
        "Sync:Subtitle": "Zeigen Sie Ihre Outlook-, Google- oder anderen Kalender in {app} an und folgen Sie {app} in anderen Kalender-Apps.",
        "Sync:SubtitleResource": "Folgen Sie {app} in Outlook, Google Kalender oder einer anderen Kalender-App.",
        "Sync:ExternalTitle": "Externe Kalender ({count}/{max})",
        "Sync:ExternalHint": "Alle 15 Minuten aktualisiert. Nur Sie sehen sie, außer Sie teilen sie.",
        "Sync:MaxReached": "Sie können bis zu {max} Kalender synchronisieren.",
        "Sync:EmptyTitle": "Noch kein externer Kalender",
        "Sync:EmptyBody": "Fügen Sie den .ics-Link eines Outlook- oder Google-Kalenders ein, um seine Termine in {app} zu sehen.",
        "Sync:NewCalendar": "neuer Kalender",
        "Sync:NameLabel": "Name",
        "Sync:NamePlaceholder": "z. B. Teamurlaub",
        "Sync:UrlLabel": ".ics-Link",
        "Sync:UrlPlaceholder": "https://…/calendar.ics",
        "Sync:UrlHelp": "Beginnt mit https:// und endet mit .ics",
        "Sync:ColorLabel": "Farbe",
        "Sync:StatusNew": "Noch nicht gespeichert",
        "Sync:StatusChecking": "Wird geprüft…",
        "Sync:StatusIssue": "Verbindungsproblem",
        "Sync:ShareToggle": "Den anderen Mitgliedern von {app} anzeigen",
        "Sync:Remove": "Entfernen",
        "Sync:RemoveConfirm": "„{name}“ entfernen? Seine Termine verschwinden aus Ihrer Ansicht.",
        "Sync:PublishTitle": "{app} in einer anderen App folgen",
        "Sync:PublishBody": "Abonnieren Sie diese Adresse in Outlook, Google Kalender oder jeder App, die das iCal-Format liest. Halten Sie sie privat: Jeder mit dem Link sieht Ihre Termine.",
        "Sync:PublishLocked": "Mit Platinum verfügbar",
        "Sync:Copy": "Link kopieren",
        "Sync:Copied": "Kopiert",
        "Sync:FixErrors": "Füllen Sie die markierten Felder aus, um zu speichern.",
        "Sync:UpgradeTitle": "Kalendersynchronisierung gibt es mit Platinum",
        "Sync:UpgradeBody": "Holen Sie bis zu 3 externe Kalender in {app} und folgen Sie ihm in anderen Kalender-Apps.",
        "Permissions:Search": "Nach Mitgliedern suchen",
        "Permissions:TableName": "Name",
        "Permissions:TableRole": "Rolle",
        "Reminds:Permissions:Tableadd": "Hinzufügen",
        "Reminds:Permissions:Tableupdate": "Bearbeiten",
        "Reminds:Permissions:Tabledelete": "Löschen",
        "Calendar:Permissions:Tableadd": "Hinzufügen",
        "AiCalendar:Permissions:Tableadd": "Hinzufügen",
        "Calendar:Permissions:Tableupdate": "Bearbeiten",
        "AiCalendar:Permissions:Tableupdate": "Bearbeiten",
        "Calendar:Permissions:Tabledelete": "Löschen",
        "AiCalendar:Permissions:Tabledelete": "Löschen",
        "Calendar:Permissions:TableallowShareSynchro": "Kalenderfreigabe",
        "AiCalendar:Permissions:TableallowShareSynchro": "Kalenderfreigabe",
        "Calendar:Permissions:TableallowEditMeetingScheduler": "Besprechungsplaner",
        "Booking:Permissions:Tableadd": "Hinzufügen",
        "Booking:Permissions:Tableupdate": "Bearbeiten",
        "Booking:Permissions:Tabledelete": "Löschen",
        "Parking:Permissions:Tableadd": "Hinzufügen",
        "Parking:Permissions:Tableupdate": "Bearbeiten",
        "Parking:Permissions:Tabledelete": "Löschen",
        "Contact:Permissions:Tableadd": "Hinzufügen",
        "Contact:Permissions:Tableupdate": "Bearbeiten",
        "Contact:Permissions:Tabledelete": "Löschen",
        "Keepass:Permissions:Tableadd": "Hinzufügen",
        "Keepass:Permissions:Tableupdate": "Bearbeiten",
        "Keepass:Permissions:Tabledelete": "Löschen / Wiederherstellen",
        "Permissions:CancelButton": "Abbrechen",
        "Permissions:SaveButton": "Speichern",
        "Permissions:AddMemberButton": "Mitglied hinzufügen",
        "Permissions:GeneralSetting": "Standardberechtigungen",
        "Reminds:Permissions:addInfo": "Benutzer kann Erinnerungen hinzufügen",
        "Reminds:Permissions:updateInfo": "Benutzer kann Ereignisse bearbeiten",
        "Reminds:Permissions:deleteInfo": "Benutzer kann Ereignisse löschen",
        "Calendar:Permissions:addInfo": "Benutzer kann Ereignisse hinzufügen",
        "AiCalendar:Permissions:addInfo": "Benutzer kann Ereignisse hinzufügen",
        "Calendar:Permissions:updateInfo": "Benutzer kann Ereignisse bearbeiten",
        "AiCalendar:Permissions:updateInfo": "Benutzer kann Ereignisse bearbeiten",
        "Calendar:Permissions:deleteInfo": "Benutzer kann Ereignisse löschen",
        "AiCalendar:Permissions:deleteInfo": "Benutzer kann Ereignisse löschen",
        "Calendar:Permissions:allowEditMeetingSchedulerInfo": "Der Benutzer kann die Einstellungen des Besprechungsplaners verwalten",
        "Calendar:Permissions:allowShareSynchroInfo": "Benutzer kann seine synchronisierten Kalender mit jedem teilen",
        "AiCalendar:Permissions:allowShareSynchroInfo": "Benutzer kann seine synchronisierten Kalender mit jedem teilen",
        "Booking:Permissions:addInfo": "Benutzer kann Buchung hinzufügen",
        "Booking:Permissions:updateInfo": "Benutzer kann Buchung bearbeiten",
        "Booking:Permissions:deleteInfo": "Benutzer kann Buchung löschen",
        "Parking:Permissions:addInfo": "Benutzer kann Buchung hinzufügen",
        "Parking:Permissions:updateInfo": "Benutzer kann Buchung bearbeiten",
        "Parking:Permissions:deleteInfo": "Benutzer kann Buchung löschen",
        "Contact:Permissions:addInfo": "Der Benutzer wird Kontakte und Gruppen hinzufügen können",
        "Contact:Permissions:updateInfo": "Der Benutzer wird Kontakte und Gruppen bearbeiten können",
        "Contact:Permissions:deleteInfo": "Der Benutzer wird Kontakte und Gruppen löschen können",
        "Keepass:Permissions:addInfo": "Benutzer kann Passwörter hinzufügen",
        "Keepass:Permissions:updateInfo": "Benutzer kann Passwörter bearbeiten",
        "Keepass:Permissions:deleteInfo": "Benutzer kann Passwörter löschen und wiederherstellen",
        "Permissions:Owner": "Besitzer",
        "Permissions:Admin": "Administrator",
        "Permissions:Member": "Mitglied",
        "Permissions:MemberIsNotPlatinum": "Anpassung exklusiv für Platinum-Abonnenten",
        "Permissions:EveryoneDropdown": "Jeder in diesem Kanal kann {taskName} hinzufügen/bearbeiten/löschen",
        "Permissions:CreatorDropdown": "Nur der/die Besitzer dieses {appTitle} kann {taskName} hinzufügen/bearbeiten/löschen",
        "Permissions:CustomDropdown": "Berechtigungen anpassen",
        "Permissions:Platinum": "Platinum",
        "Permissions:Premium": "<a href='https://admin.teams-pro.com/users' target='_blank'>Premium</a>",
        "Permissions:Free": "<a href='https://admin.teams-pro.com/users' target='_blank'>Kostenlos</a>",
        "Permissions:AssignLicense": "Klicken Sie hier, um eine Platinum-Lizenz zuzuweisen 🚀",
        "Permissions:Subscription": "Abonnement",
        "Booking:taskName": "Buchungen",
        "Parking:taskName": "Buchungen",
        "Reminds:taskName": "Ereignisse",
        "Calendar:taskName": "Ereignisse",
        "AiCalendar:taskName": "Ereignisse",
        "Gantt:taskName": "Aufgaben",
        "Keepass:taskName": "Passwörter",
        "Contact:taskName": "Kontakte und Gruppen",
        AddMembers: "Mitglieder hinzufügen",
        AddMembersTagLine: "Geben Sie die E-Mail-Adresse der Person ein, die Sie hinzufügen möchten",
        EmailAddress: "E-Mail-Adresse eingeben",
        SaveAlert: "Ihre Änderungen wurden erfolgreich gespeichert!",
        CancelTagLine: "Wenn Sie jetzt fortfahren, werden alle von Ihnen vorgenommenen Änderungen verworfen. Möchten Sie wirklich fortfahren?",
        Continue: "Weiter",
        Return: "Zurück",
        "Permissions:FreeRedirect": "Sie verwenden eine kostenlose Version von {appTitle}.",
        "Permissions:PremiumRedirect": "Sie verwenden eine Premium-Version von {appTitle}.",
        "Sync:PremiumRedirect": "Sie verwenden eine Premium-Version von {appTitle}. Upgraden Sie auf Platinum 🚀 und verwalten Sie Synchronisierungen!",
        "Sync:FreeRedirect": "Sie verwenden eine kostenlose Version von {appTitle}. Upgraden Sie auf Platinum 🚀 und verwalten Sie Synchronisierungen!",
        NotAllowed: "Sie dürfen die Berechtigungen nicht ändern.",
        NotAllowedNotif: "Sie dürfen diese Einstellungen nicht ändern.",
        CancelModifications: "Änderungen abbrechen",
        "Sync:Title": "Kalender synchronisieren",
        "Sync:Manage": "Verwalten",
        "Sync:Synchronize": "Synchronisieren",
        "Sync:Add": "Kalender hinzufügen",
        "Sync:SyncCalendarTitle": "Kalender auf meinem synchronisieren",
        "Sync:ShareTitle": "Teilen Sie mein ",
        "Sync:CalendarName": "Name des Kalenders",
        "Sync:ICSLink": ".ICS-Link des Kalenders",
        "Sync:PublicAddress": "Öffentliche Adresse im iCal-Format",
        "Sync:TableName": "Name",
        "Sync:TableColor": "Farbe",
        "Sync:TableShow": "Teilen",
        "Sync:TableState": "Status",
        "Sync:SynchronizeLine": "Um alle Ihre Kalender an einem Ort zu verwalten, synchronisieren Sie Ihren Kalender.",
        "Sync:SyncCalendarTooltip": "Sie können maximal 3 Kalender synchronisieren. Ihr Kalender wird alle 15 Minuten synchronisiert.",
        "Sync:SyncTitle": "Externer Kalender hinzufügen",
        AddAlert: "Die Mitglieder wurden erfolgreich hinzugefügt",
        "Sync:ICSInput": "Geben Sie eine URL ein",
        "Sync:NameInput": "Geben Sie einen Namen ein",
        "Sync:TableAction": "Aktion",
        "Sync:ManageTooltip": "Sie haben keinen einzigen synchronisierten Kalender",
        AddressTitle: "Adresse",
        AddAddress: "Geben Sie hier eine Adresse ein, um sie zu suchen",
        Participants: "Teilnehmer",
        NoParticipants: "Keine Ergebnisse gefunden",
        "Sync:TabTooltip": "Sie müssen Ihre Änderungen speichern/abbrechen",
        "Sync:DeleteCalendar": "Kalender löschen",
        "Sync:DeleteTagLine": "Wenn Sie jetzt fortfahren, wird Ihr Kalender aus Ihrer Ansicht gelöscht. Um ihn erneut anzuzeigen, müssen Sie ihn erneut synchronisieren.",
        "Sync:NotAllowToShare": "Die Besitzer des Kalenders haben Ihnen nicht erlaubt, Ihre Kalender mit anderen zu teilen",
        "Sync:ConnectionIssue": "Problem mit der Kalenderverbindung festgestellt. Überprüfen Sie die Existenz des Kalenders und den Verbindungsstatus für eine reibungslose Synchronisierung.",
        "Permissions:CreatorRole": "Besitzer dieses Kalenders",
        Synchronized: "Synchronisiert",
        Unsynchronized: "Nicht synchronisiert",
        "Sync:UnsynchronizedTooltip": "Problem mit der Kalenderverbindung festgestellt. Überprüfen Sie die Existenz des Kalenders und den Verbindungsstatus für eine reibungslose Synchronisierung",
        "Sync:ShareInfo": "Teilen Sie diesen Kalender mit Mitgliedern auf",
        AddParticipantsButton: "Teilnehmer hinzufügen",
        "Sync:getErrorMessage": "Es ist ein Fehler mit Ihrem ICS-Link aufgetreten, auf dem Kalender:",
        "Permissions:ManageRoleTitle": "Bestätigung der Rollenänderung",
        "Permissions:ManageRoleTagLine": "Sie sind dabei, die Rolle eines Mitglieds in Ihrem Tab zu ändern. Durch die Fortsetzung gewähren Sie Rechte, die Sie einem Mitglied nicht entziehen können. Möchten Sie wirklich fortfahren?",
        NotifDialogHeader: "Teams-Benachrichtigungseinstellungen",
        RedirectToAppSource: "<p style='text-align: center;'>Wir bringen Sie zum Microsoft Marketplace. Wenn Sie nicht weitergeleitet werden, <a target='_blank' href='{link}'>klicken Sie hier</a>.</p>",
        WhatsNewsOn: "Was gibt's Neues?",
        NewsSoon: "Neuigkeiten kommen bald!",
        NeedConsentTitle: "Zustimmung erforderlich",
        NeedConsent: "Um diese Aktion auszuführen, benötigen wir Ihre Zustimmung. Wenn Sie zustimmen, werden Sie zur Zustimmungsseite weitergeleitet.",
        NoAddress: "Keine Ergebnisse auf Google Maps gefunden",
        YourInfo: "Ihre Informationen",
        ChooseTime: "Datum und Uhrzeit wählen",
        IC_SuperAdminTitle: "Warnung",
        IC_SuperAdminExpiredCardMessage: "Ihre Zahlungsinformationen laufen bald ab. Bitte aktualisieren Sie sie, um einen Serviceausfall zu vermeiden.",
        IC_SuperAdminPaymentDueMessage: "Auf Ihrem Konto befinden sich ausstehende Rechnungen. Bitte begleichen Sie diese, um Unterbrechungen des Dienstes zu vermeiden.",
        IC_SuperAdminCTA: "Zum Admin Center gehen",
        IC_AdminTitle: "Warnung",
        IC_AdminExpiredCardMessage: "Die Zahlungsmethode, die mit Ihrer Lizenz verknüpft ist, läuft bald ab.",
        IC_AdminPaymentDueMessage: "Wir konnten die Zahlung für Ihre Lizenz nicht verarbeiten, um Unterbrechungen des Dienstes zu vermeiden",
        IC_AdminExpiredCardCTA: "Klicken Sie hier, um Ihren Super Admin zu benachrichtigen.",
        IC_AdminPaymentDueCTA: "klicken Sie hier, um Ihren Super Admin zu benachrichtigen.",
        IC_NotifTitle: "Aufmerksamkeit erforderlich",
        IC_NotifMessage: "Bitte greifen Sie auf {appName} zu, um wichtige Updates zu erhalten",
        PreventUnlockPremiumFeaturesOnMobile: "Um auf die Premium/Platinum-Version zu upgraden, verwenden Sie bitte Teams auf dem Desktop oder im Web.",
        GoToAdminCenter: "Zum Admin Center gehen",
        PremiumMessage1: "Sie verwenden eine Premium-Version von {appTitle}.",
        ClickHere: "Hier klicken 🚀",
        PremiumMessage2: "um auf Platinum zu aktualisieren und Berechtigungen effektiver zu verwalten!",
        DiscardMessageTitle: "Nicht gespeicherte Änderungen",
        DiscardChanges: "Verwerfen",
        ContinueEditing: "Bearbeitung fortsetzen",
        DiscardMessage: "Möchten Sie Änderungen verwerfen oder mit der Bearbeitung fortfahren ?",
        VisitLink: "Den Link besuchen",
        SelectCustomize: "Um Berechtigungen anzupassen, wählen Sie 'Berechtigungen anpassen' oben",
        SaveBeforeSearch: "Speichern Sie Ihre Änderungen, bevor Sie suchen",
        AccessMaster: "Dieser Ben utzer hat Zugriff auf das Master-Passwort",
        FeaturesNowAvailable: "Genießen Sie jetzt alle Ihre neuen Funktionen!",
        KnowAboutFeatures: "Um mehr über die Ihnen zur Verfügung stehenden Funktionen zu erfahren, klicken Sie <a target='_blank' href='{link}'>hier</a>!",
        Go: "Los geht's!",
        NeedToBuyLicences: "Sie müssen Lizenzen kaufen",
        HaveLicencesButNotEnough: "Sie haben bereits einige Lizenzen, aber sie sind alle zugewiesen. Sie müssen mehr Lizenzen kaufen, um sich selbst eine zuweisen zu können.",
        BuyMoreLicence: "Mehr Lizenzen kaufen",
        GeneralPermissionsSettings: "Allgemeine Berechtigungseinstellungen",
        CustomizedPermissionsSettings: "Angepasste Berechtigungseinstellungen",
        About: "Über",
        ReviewTitleJoin: "Werden Sie einer von Tausenden Nutzern, die {appName} lieben!",
        ReviewSubtitleShare: "Helfen Sie anderen, die App zu entdecken, indem Sie Ihre Erfahrung teilen",
        ReviewQuote: "Die besten Apps entstehen durch Nutzerfeedback",
        ThanksForYourRating: "Vielen Dank für Ihre Bewertung",
        ReviewFeedbackQuestion: "Wir würden uns über Ihr Feedback freuen! Es dauert nur zwei Minuten.",
        WhatCouldWeImprove: "Was könnten wir verbessern? 💭",
        SubmitMyFeedback: "Mein Feedback senden",
        FillCompleteFeedbackForm: "Unser vollständiges Feedback-Formular ausfüllen",
        MaybeLater: "Vielleicht später",
        ReviewOnAppSource: "Bewertung auf AppSource",
        Version: "Version",
        UniqueID: "Eindeutige Kennung",
        Copied: "Kopiert!",
        Copy: "Kopieren",
        CreatedBy: "Erstellt von",
        SuggestFeature: "Funktion vorschlagen",
        HelpCenter: "Hilfezentrum",
        MoreApps: "Weitere Apps",
        "Sync:NoUrlErrorMessage": "Bitte füllen Sie dieses Feld mit einem gültigen ics-Link aus",
        "Sync:NoNameErrorMessage": "Bitte fügen Sie diesem Kalender einen Namen hinzu",
        "Sync:StartUrlErrorMessage": 'Bitte geben Sie einen gültigen ics-Link ein, der mit "https://" beginnt',
        "Sync:EndUrlErrorMessage": 'Bitte geben Sie einen gültigen ics-Link ein, der mit ".ics" endet',
        no_reason: "Ich brauche die App nicht mehr",
        technical_issue: "Technische Probleme oder Fehler",
        bad_interface: "Schwierig zu benutzen oder zu verstehen",
        limited_features: "Begrenzte Funktionen oder eingeschränkte Funktionalität",
        switching_to_another_app: "Wechsel zu einer anderen Lösung",
        temporary_uninstallation: "Temporäre Deinstallation (ich könnte zurückkommen)",
        UninstallReason: "Grund",
        UninstallComment: "Kommentar",
        "Rte:StartUrlErrorMessage": 'Bitte geben Sie einen gültigen Link ein, er sollte mit "https://" beginnen',
        "Rte:InsertLink": "Link einfügen",
        "Rte:TextToDisplay": "Anzuzeigender Text",
        "Rte:Address": "Adresse",
        "Rte:AddressPlaceholder": "Link zu einer bestehenden Webseite",
        "Rte:NoHighlight": "Kein Hervorheben",
        "Rte:ByDefault": "Standardmäßig",
        "Rte:Large": "Groß",
        "Rte:Medium": "Mittel",
        "Rte:InsertImageLink": "Bildlink einfügen",
        "Rte:ImageAddressPlaceholder": "Link zu einem vorhandenen Bild im Web",
        UnlockPlatinum: "Platinum freischalten",
        UpgradePlatinumDescription: "Upgrade auf Platinum für Ihr Team. Verwalten Sie Benutzerberechtigungen und greifen Sie auf erweiterte Funktionen für Administratoren zu.",
        AdvancedTeamManagement: "Erweiterte Teamverwaltung",
        ControlUserPermissions: "Benutzerberechtigungen und Zugriffsrechte steuern",
        PlatinumFeatures: "Platinum-Funktionen",
        AccessAllPlatinumTools: "Zugriff auf alle Platinum-Tools und Funktionen",
        UnlockPremium: "Premium freischalten",
        CalendarUpgradePremiumDescription: "Upgrade auf Premium für Ihr Team. Planen Sie wiederkehrende Termine, organisieren Sie sie und teilen Sie Ihren Kalender.",
        CalendarPremiumRecurrence: "Wiederkehrende Termine",
        CalendarPremiumRecurrenceDescription: "Wiederholen Sie Ihre Termine täglich, wöchentlich oder monatlich",
        CalendarPremiumOrganize: "Tags und Emoji",
        CalendarPremiumOrganizeDescription: "Organisieren und markieren Sie Ihre Termine",
        CalendarPremiumShare: "Teilen und drucken",
        CalendarPremiumShareDescription: "Teilen Sie Ihre Termine und drucken Sie Ihren Kalender",
        PrioritySupport: "Priorisierter Support",
        DedicatedAssistance: "Dedizierte Unterstützung",
        LearnMoreFeatures: "Mehr über die Funktionen erfahren",
        "CookieDialogAnswer": "Machen Sie {appName} zu Ihrem besten Tool",
        "Experience": "Meine Erfahrung verbessern:",
        "ExperienceDesc": "Leistung optimieren, Fehler schneller beheben und Funktionen priorisieren, die Sie am häufigsten verwenden.",
        "Offer": "Personalisierte Angebote erhalten:",
        "OfferDesc": "Tipps, Updates und Werbeaktionen, die auf Ihre Nutzung zugeschnitten sind. Kein Spam. Sie können sich jederzeit abmelden.",
        "AcceptAll": "Alle akzeptieren",
        "Consent_Title": "Holen Sie mehr aus {appName} heraus ✨",
        "Consent_Subtitle": "Produkt-Tipps und Angebote per E-Mail sowie Nutzungsstatistiken, die uns helfen, {appName} zu verbessern. Optional und standardmäßig aus. Jederzeit änderbar.",
        "Consent_Footer": "Diese Auswahl betrifft niemals Ihre Daten in {appName}. Was Sie in der App erstellen, wird nicht weitergegeben und niemals für Marketing verwendet.",
        "Consent_TrustRow": "Von Witivio · Microsoft-Partner · Jederzeit abbestellbar",
        "Consent_Marketing": "Tipps und Angebote per E-Mail erhalten",
        "Consent_MarketingDesc": "Etwa einmal im Monat: Produkt-Tipps, Neuigkeiten und Angebote. Abmelden mit einem Klick, jederzeit.",
        "Consent_Experience": "Mithelfen, {appName} zu verbessern",
        "Consent_ExperienceDesc": "Teilen Sie, wie Sie {appName} nutzen, damit wir Fehler schneller beheben und die Funktionen entwickeln, die Sie am häufigsten nutzen. Niemals die Inhalte, die Sie in der App erstellen.",
        "Consent_EnableAll": "Alle akzeptieren ✨",
        "Consent_Customize": "Anpassen",
        "Consent_Save": "Meine Auswahl speichern",
        "Consent_Cancel": "Abbrechen",
        "Consent_Saved": "Gespeichert ✅ Das haben Sie aktiviert:",
        "Consent_Declined": "Alles klar. Nichts wird geteilt.",
        "Consent_ResultMarketing": "• Tipps und Angebote per E-Mail",
        "Consent_ResultExperience": "• Einblicke zur Produktverbesserung",
        "Consent_ManageHint": "Jederzeit änderbar über das Symbolleistenmenü: Datenschutzeinstellungen.",
        "Consent_PrivacyMenu": "Datenschutzeinstellungen",
        "ConsentScreen_Title": "Noch ein letzter Schritt",
        "ConsentScreen_Subtitle": "Diese App arbeitet mit Ihrem Microsoft 365-Konto. Erlauben Sie den Zugriff einmal, dann kann es losgehen.",
        "ConsentScreen_Allow": "Zugriff erlauben",
        "ConsentScreen_Waiting": "Warten auf Microsoft…",
        "ConsentScreen_Finishing": "Wird eingerichtet…",
        "ConsentScreen_TryAgain": "Erneut versuchen",
        "ConsentScreen_Hint": "Ein Microsoft-Fenster öffnet sich zur Bestätigung. Ihr Passwort wird nie an die App weitergegeben.",
        "ConsentScreen_Revoke": "Sie können diesen Zugriff jederzeit unter {link} entfernen.",
        "ConsentScreen_FailedTitle": "Zugriff wurde nicht erteilt",
        "ConsentScreen_FailedText": "Das Microsoft-Fenster wurde geschlossen, bevor der Zugriff erlaubt wurde. Stand dort „Administratorgenehmigung erforderlich“, kann nur ein IT-Administrator diese App genehmigen: Senden Sie ihm den Link unten.",
        "ConsentScreen_AdminToggle": "Administratorgenehmigung erforderlich?",
        "ConsentScreen_AdminText": "Senden Sie diesen Link an Ihren IT-Administrator. Nach der Genehmigung gilt der Zugriff für Ihre gesamte Organisation.",
        "ConsentScreen_CopyLink": "Link kopieren",
        "ConsentScreen_Copied": "Link kopiert",
        "ConsentScreen_LinkLabel": "Link zur Administratorgenehmigung",
        "OnboardingTour:MenuEntry": "Geführte Tour",
        "OnboardingTour:HowToUse": "So nutzen Sie es",
        "OnboardingTour:Step": "{current} von {total}",
        "OnboardingTour:Start": "Tour starten",
        "OnboardingTour:Next": "Weiter",
        "OnboardingTour:Back": "Zurück",
        "OnboardingTour:Skip": "Überspringen",
        "OnboardingTour:Done": "Verstanden",
    },
    it: {
        UnlockPremiumFeatures: "Sblocca Premium per abilitare più funzionalità",
        UpgradePremium: "Aggiorna a Premium",
        UpgradePlatinum: "Aggiorna a Platinum",
        Cancel: "Annulla",
        Insert: "Inserisci",
        ThanksPurchase: "Grazie per l'acquisto",
        PremiumNowAvailable: "Ora puoi godere di tutte le funzionalità premium",
        ManageLicences: "Gestisci licenze",
        Close: "Chiudi",
        RequestAccess: "Richiedi accesso",
        UpgradeTeamMessage: "Passa a Premium per il tuo team. Sarai in grado di gestire i membri che avranno accesso alla versione Premium.",
        UpgradePlatinumTeamMessage: "Passa a Platinum per il tuo team. Sarai in grado di gestire i membri che avranno accesso alla versione Platinum.",
        TeamHasLicences: "La tua azienda ha già effettuato l'upgrade a Premium. Lascia un messaggio all'amministratore per richiedere l'accesso.",
        NoPremiumAccess: "Non hai accesso Premium",
        TeamHasPlatinumLicences: "La tua azienda ha già effettuato l'upgrade a Platinum. Lascia un messaggio all'amministratore per richiedere l'accesso.",
        NoPlatinumAccess: "Non hai accesso Platinum",
        RequestAccessMessage: "Lascia un messaggio all'amministratore per richiedere l'accesso. Verrà notificato e ti verrà concesso l'accesso presto.",
        Send: "Invia",
        AdministratorNotified: "L'amministratore è stato notificato. Riceverai una email quando sarà completato.",
        DefaultRequestMessage: "Ciao, sono {userName} e vorrei avere accesso Premium su {appTitle}. Grazie.",
        RequestAccessInApprobation: "Una richiesta di accesso è in fase di approvazione. Se hai fretta, attiva Premium ora",
        "RequestAccess:Title": "Richiedi l'accesso a {appTitle}",
        "RequestAccess:Subtitle": "La tua organizzazione è già abbonata a questa app: un amministratore deve solo assegnarti una licenza.",
        "RequestAccess:Step1": "I tuoi amministratori ricevono la tua richiesta via email",
        "RequestAccess:Step2": "Uno di loro ti assegna una licenza",
        "RequestAccess:Step3": "Ricevi un'email non appena il tuo accesso è attivo",
        "RequestAccess:MessageLabel": "Messaggio ai tuoi amministratori",
        "RequestAccess:Send": "Invia richiesta",
        "RequestAccess:Pending": "Hai già una richiesta in attesa di approvazione. Riceverai un'email non appena un amministratore risponderà.",
        "RequestAccess:Failed": "Impossibile inviare la richiesta. Riprova tra un momento.",
        SendMessage: "Invia messaggio",
        Call: "Chiama",
        System: "Sistema",
        Unknown: "Sconosciuto",
        TokenExpired: "Token scaduto",
        PleaseRefreshTab: "Aggiorna la scheda per favore",
        AnErrorOccured: "Si è verificato un errore",
        Consent: "Consenso",
        NeedToConsent: "È necessario dare il consenso",
        ClickButtonToContinue: "Clicca sul pulsante per continuare",
        SearchATeam: "Cerca un team",
        JoinTeam: "Unisciti al team",
        Teams: "Team",
        EditTextConfirm: "Salva",
        EditTextEdit: "Modifica",
        EditTextRemove: "Rimuovi",
        EditTextLink: "Link",
        "Permissions:Title": "Permessi",
        "Page:Back": "Indietro",
        "Premium:LicenceHint": "Buone notizie: la tua organizzazione ha già licenze {appTitle}. Chiedi al tuo amministratore di assegnartene una.",
        "Premium:RequestLicence": "Richiedi una licenza al mio amministratore",
        "AdminLicence:Badge": "Amministratore",
        "AdminLicence:Title": "Assegnati una licenza {plan}",
        "AdminLicence:Subtitle": "La tua organizzazione dispone già di licenze {appTitle}. Come amministratore, puoi assegnartene una in pochi clic, senza alcun acquisto.",
        "AdminLicence:Hint": "Dalla stessa pagina puoi anche assegnare licenze ai tuoi colleghi.",
        "AdminLicence:Assign": "Assegnami una licenza",
        "Page:UpgradeCta": "Passa a un piano superiore",
        "SaveBar:Unsaved": "Hai modifiche non salvate",
        "SaveBar:Discard": "Annulla modifiche",
        "SaveBar:Save": "Salva modifiche",
        "SaveBar:Saved": "Modifiche salvate.",
        "SaveBar:Failed": "Non è stato possibile salvare le modifiche. Riprova.",
        "Permissions:Subtitle": "Scegli chi può aggiungere, modificare ed eliminare {taskName}.",
        "Permissions:ModeTitle": "Chi può apportare modifiche",
        "Permissions:ModeEveryoneTitle": "Tutti",
        "Permissions:ModeEveryoneBody": "Ogni membro del canale può aggiungere, modificare ed eliminare {taskName}.",
        "Permissions:ModeOwnersTitle": "Solo i proprietari",
        "Permissions:ModeOwnersBody": "I membri vedono {taskName}; solo i proprietari di {appTitle} possono modificarli.",
        "Permissions:ModeCustomTitle": "Personalizzato",
        "Permissions:ModeCustomBody": "Scegli, membro per membro, chi può aggiungere, modificare ed eliminare {taskName}.",
        "Permissions:CustomHint": "Scegli Personalizzato per impostare i diritti di ogni membro.",
        "Permissions:ReadOnly": "Solo i proprietari possono modificare i permessi. Qui puoi consultarli.",
        "Permissions:UpgradeTitle": "I permessi personalizzati sono inclusi in Platinum",
        "Permissions:UpgradeBody": "Decidi membro per membro chi può aggiungere, modificare ed eliminare {taskName}.",
        "Permissions:LicencePremium": "Premium",
        "Permissions:LicenceFree": "Gratuito",
        "Permissions:MakeOwner": "Rendi proprietario",
        "Permissions:You": "Tu",
        "Permissions:Loading": "Caricamento dei membri…",
        "Permissions:NoMatch": "Nessun membro corrisponde a “{search}”.",
        "Permissions:NoMembers": "Ancora nessun membro",
        "Permissions:NoMembersBody": "Aggiungi membri per dare loro diritti propri.",
        "Permissions:PageInfo": "{from}–{to} di {total}",
        "Permissions:PreviousPage": "Pagina precedente",
        "Permissions:NextPage": "Pagina successiva",
        "Permissions:MembersTitle": "Membri ({count})",
        "Permissions:AddMembers": "Aggiungi membri",
        "Permissions:LockedWhileDirty": "Salva o annulla le modifiche per cercare o cambiare pagina.",
        "Sync:Subtitle": "Visualizza i tuoi calendari Outlook, Google o altri in {app} e segui {app} da altre app di calendario.",
        "Sync:SubtitleResource": "Segui {app} da Outlook, Google Calendar o qualsiasi altra app di calendario.",
        "Sync:ExternalTitle": "Calendari esterni ({count}/{max})",
        "Sync:ExternalHint": "Aggiornati ogni 15 minuti. Li vedi solo tu, a meno che non li condividi.",
        "Sync:MaxReached": "Puoi sincronizzare fino a {max} calendari.",
        "Sync:EmptyTitle": "Ancora nessun calendario esterno",
        "Sync:EmptyBody": "Incolla il link .ics di un calendario Outlook o Google per vederne gli eventi in {app}.",
        "Sync:NewCalendar": "nuovo calendario",
        "Sync:NameLabel": "Nome",
        "Sync:NamePlaceholder": "Es. Ferie del team",
        "Sync:UrlLabel": "Link .ics",
        "Sync:UrlPlaceholder": "https://…/calendar.ics",
        "Sync:UrlHelp": "Inizia con https:// e termina con .ics",
        "Sync:ColorLabel": "Colore",
        "Sync:StatusNew": "Non ancora salvato",
        "Sync:StatusChecking": "Verifica in corso…",
        "Sync:StatusIssue": "Problema di connessione",
        "Sync:ShareToggle": "Mostralo agli altri membri di {app}",
        "Sync:Remove": "Rimuovi",
        "Sync:RemoveConfirm": "Rimuovere “{name}”? I suoi eventi spariranno dalla tua vista.",
        "Sync:PublishTitle": "Segui {app} da un'altra app",
        "Sync:PublishBody": "Iscriviti a questo indirizzo da Outlook, Google Calendar o qualsiasi app che legge il formato iCal. Tienilo privato: chiunque abbia il link vede i tuoi eventi.",
        "Sync:PublishLocked": "Disponibile con Platinum",
        "Sync:Copy": "Copia link",
        "Sync:Copied": "Copiato",
        "Sync:FixErrors": "Completa i campi evidenziati per salvare.",
        "Sync:UpgradeTitle": "La sincronizzazione dei calendari è inclusa in Platinum",
        "Sync:UpgradeBody": "Porta fino a 3 calendari esterni in {app} e seguilo da altre app di calendario.",
        "Permissions:Search": "Cerca membri",
        "Permissions:TableName": "Nome",
        "Permissions:TableRole": "Ruolo",
        "Reminds:Permissions:Tableadd": "Aggiungi",
        "Reminds:Permissions:Tableupdate": "Modifica",
        "Reminds:Permissions:Tabledelete": "Elimina",
        "Calendar:Permissions:Tableadd": "Aggiungi",
        "AiCalendar:Permissions:Tableadd": "Aggiungi",
        "Calendar:Permissions:Tableupdate": "Modifica",
        "AiCalendar:Permissions:Tableupdate": "Modifica",
        "Calendar:Permissions:Tabledelete": "Elimina",
        "AiCalendar:Permissions:Tabledelete": "Elimina",
        "Calendar:Permissions:TableallowShareSynchro": "Condivisione calendario",
        "AiCalendar:Permissions:TableallowShareSynchro": "Condivisione calendario",
        "Calendar:Permissions:TableallowEditMeetingScheduler": "Pianificazione riunioni",
        "Booking:Permissions:Tableadd": "Aggiungi",
        "Booking:Permissions:Tableupdate": "Modifica",
        "Booking:Permissions:Tabledelete": "Elimina",
        "Parking:Permissions:Tableadd": "Aggiungi",
        "Parking:Permissions:Tableupdate": "Modifica",
        "Parking:Permissions:Tabledelete": "Elimina",
        "Contact:Permissions:Tableadd": "Aggiungi",
        "Contact:Permissions:Tableupdate": "Modifica",
        "Contact:Permissions:Tabledelete": "Elimina",
        "Keepass:Permissions:Tableadd": "Aggiungi",
        "Keepass:Permissions:Tableupdate": "Modifica",
        "Keepass:Permissions:Tabledelete": "Elimina / Ripristina",
        "Permissions:CancelButton": "Annulla",
        "Permissions:SaveButton": "Salva",
        "Permissions:AddMemberButton": "Aggiungi membro",
        "Permissions:GeneralSetting": "Permessi predefiniti",
        "Reminds:Permissions:addInfo": "L'utente sarà in grado di aggiungere recordatorios",
        "Reminds:Permissions:updateInfo": "L'utente sarà in grado di modificare recordatorios",
        "Reminds:Permissions:deleteInfo": "L'utente sarà in grado di eliminare recordatorios",
        "Calendar:Permissions:addInfo": "L'utente sarà in grado di aggiungere eventi",
        "AiCalendar:Permissions:addInfo": "L'utente sarà in grado di aggiungere eventi",
        "Calendar:Permissions:updateInfo": "L'utente sarà in grado di modificare eventi",
        "AiCalendar:Permissions:updateInfo": "L'utente sarà in grado di modificare eventi",
        "Calendar:Permissions:deleteInfo": "L'utente sarà in grado di eliminare eventi",
        "AiCalendar:Permissions:deleteInfo": "L'utente sarà in grado di eliminare eventi",
        "Calendar:Permissions:allowEditMeetingSchedulerInfo": "L'utente sarà in grado di gestire le impostazioni della pianificazione riunioni",
        "Calendar:Permissions:allowShareSynchroInfo": "L'utente sarà in grado di condividere i suoi calendari sincronizzati con tutti",
        "AiCalendar:Permissions:allowShareSynchroInfo": "L'utente sarà in grado di condividere i suoi calendari sincronizzati con tutti",
        "Booking:Permissions:addInfo": "L'utente sarà in grado di aggiungere prenotazioni",
        "Booking:Permissions:updateInfo": "L'utente sarà in grado di modificare prenotazioni",
        "Booking:Permissions:deleteInfo": "L'utente sarà in grado di eliminare prenotazioni",
        "Parking:Permissions:addInfo": "L'utente sarà in grado di aggiungere prenotazioni",
        "Parking:Permissions:updateInfo": "L'utente sarà in grado di modificare prenotazioni",
        "Parking:Permissions:deleteInfo": "L'utente sarà in grado di eliminare prenotazioni",
        "Contact:Permissions:addInfo": "L'utente potrà aggiungere contatti e gruppi",
        "Contact:Permissions:updateInfo": "L'utente potrà modificare contatti e gruppi",
        "Contact:Permissions:deleteInfo": "L'utente potrà eliminare contatti e gruppi",
        "Keepass:Permissions:addInfo": "L'utente potrà aggiungere password",
        "Keepass:Permissions:updateInfo": "L'utente potrà modificare password",
        "Keepass:Permissions:deleteInfo": "L'utente potrà eliminare e ripristinare password",
        "Permissions:Owner": "Proprietario",
        "Permissions:Admin": "Amministratore",
        "Permissions:Member": "Membro",
        "Permissions:MemberIsNotPlatinum": "Personalizzazione esclusiva per gli abbonati Platinum",
        "Permissions:EveryoneDropdown": "Tutti in questo canale possono aggiungere/modificare/eliminare {taskName}",
        "Permissions:CreatorDropdown": "Solo il/i proprietario/i di questo {appTitle} possono aggiungere/modificare/eliminare {taskName}",
        "Permissions:CustomDropdown": "Personalizza i permessi",
        "Permissions:Platinum": "Platinum",
        "Permissions:Premium": "<a href='https://admin.teams-pro.com/users' target='_blank'>Premium</a>",
        "Permissions:Free": "<a href='https://admin.teams-pro.com/users' target='_blank'>Gratuito</a>",
        "Permissions:AssignLicense": "Clicca per assegnare una licenza Platinum 🚀",
        "Permissions:Subscription": "Abbonamento",
        "Booking:taskName": "prenotazioni",
        "Parking:taskName": "prenotazioni",
        "Reminds:taskName": "eventi",
        "Calendar:taskName": "eventi",
        "AiCalendar:taskName": "eventi",
        "Gantt:taskName": "attività",
        "Contact:taskName": "contatti e gruppi",
        "Keepass:taskName": "password",
        AddMembers: "Aggiungi membri",
        AddMembersTagLine: "Inizia a digitare l'indirizzo email della persona che desideri aggiungere",
        EmailAddress: "Inserisci l'indirizzo email",
        SaveAlert: "Le tue modifiche sono state salvate con successo!",
        CancelTagLine: "Se procedi ora, qualsiasi modifica apportata verrà annullata. Sei sicuro di voler continuare?",
        Continue: "Continua",
        Return: "Torna",
        "Permissions:FreeRedirect": "Stai utilizzando una versione gratuita di {appTitle}.",
        "Permissions:PremiumRedirect": "Stai utilizzando una versione premium di {appTitle}.",
        "Sync:PremiumRedirect": "Stai utilizzando una versione premium di {appTitle}. Passare a Platinum 🚀 e gestire le sincronizzazioni!",
        "Sync:FreeRedirect": "Stai utilizzando una versione gratuita di {appTitle}. Passare a Platinum 🚀 e gestire le sincronizzazioni!",
        NotAllowed: "Non ti è consentito modificare i permessi.",
        NotAllowedNotif: "Non ti è consentito modificare questa impostazione.",
        CancelModifications: "Annulla modifiche",
        "Sync:Title": "Sincronizza calendari",
        "Sync:Manage": "Gestisci",
        "Sync:Synchronize": "Sincronizza",
        "Sync:Add": "Aggiungi un calendario",
        "Sync:SyncCalendarTitle": "Sincronizza calendari con il mio ",
        "Sync:ShareTitle": "Condividi il mio ",
        "Sync:CalendarName": "Nome del calendario",
        "Sync:ICSLink": "Link .ICS del calendario",
        "Sync:PublicAddress": "Indirizzo pubblico formato iCal",
        "Sync:TableName": "Nome",
        "Sync:TableColor": "Colore",
        "Sync:TableShow": "Condividi",
        "Sync:TableState": "Stato",
        "Sync:SynchronizeLine": "Per gestire tutti i tuoi calendari in un unico posto, sincronizza il tuo calendario.",
        "Sync:SyncCalendarTooltip": "Puoi sincronizzare al massimo 3 calendari. Il tuo calendario sarà sincronizzato ogni 15 minuti.",
        "Sync:SyncTitle": "Aggiungi calendario esterno",
        AddAlert: "I membri sono stati aggiunti con successo",
        "Sync:ICSInput": "Digita un URL",
        "Sync:NameInput": "Digita un nome",
        "Sync:TableAction": "Azione",
        "Sync:ManageTooltip": "Non hai un singolo calendario sincronizzato",
        AddressTitle: "Indirizzo",
        AddAddress: "Digita qui per cercare un indirizzo",
        Participants: "Partecipanti",
        NoParticipants: "Nessun risultato trovato",
        "Sync:TabTooltip": "Devi salvare/annullare le tue modifiche",
        "Sync:DeleteCalendar": "Elimina calendario",
        "Sync:DeleteTagLine": "Se procedi ora, il tuo calendario verrà eliminato dalla tua visualizzazione. Per vederlo di nuovo, dovrai sincronizzarlo nuovamente.",
        "Sync:NotAllowToShare": "I proprietari del calendario non ti permettono di condividere i tuoi calendari con gli altri",
        "Sync:ConnectionIssue": "Rilevato problema di connessione al calendario. Verifica l'esistenza del calendario e lo stato della connessione per una sincronizzazione senza problemi.",
        "Permissions:CreatorRole": "Proprietario di questo calendario",
        Synchronized: "Sincronizzato",
        Unsynchronized: "Non sincronizzato",
        "Sync:UnsynchronizedTooltip": "Rilevato problema di connessione al calendario. Verifica l'esistenza del calendario e lo stato della connessione per una sincronizzazione senza problemi.",
        "Sync:ShareInfo": "Condividi questo calendario con i membri su ",
        AddParticipantsButton: "Aggiungi partecipanti",
        "Sync:getErrorMessage": "Si è verificato un errore con il tuo link ICS sul calendario: ",
        "Permissions:ManageRoleTitle": "Conferma cambio ruolo",
        "Permissions:ManageRoleTagLine": "Stai per cambiare il ruolo di un membro nella tua scheda. Procedendo, concederai diritti che non sarai in grado di revocare da un membro. Sei sicuro di voler continuare?",
        NotifDialogHeader: "Impostazioni notifica di Teams",
        RedirectToAppSource: "<p style='text-align: center;'>Ti stiamo reindirizzando al Marketplace di Microsoft. Se non sei reindirizzato, <a target='_blank' href='{link}'>clicca qui</a>.</p>",
        WhatsNewsOn: "Novità",
        NewsSoon: "Le novità arriveranno presto!",
        NeedConsentTitle: "Necessità di consenso",
        NeedConsent: "Per eseguire questa azione avremo bisogno del consenso. Se confermi, verrai reindirizzato alla pagina di consenso.",
        NoAddress: "Nessun risultato trovato su Google Maps",
        YourInfo: "Le tue informazioni",
        ChooseTime: "Scegli data e ora",
        IC_SuperAdminTitle: "Attenzione",
        IC_SuperAdminExpiredCardMessage: "Le tue informazioni di pagamento stanno per scadere, ti preghiamo di aggiornarle per evitare interruzioni del servizio.",
        IC_SuperAdminPaymentDueMessage: "Il tuo account ha fatture in sospeso. Ti preghiamo di saldarle per evitare interruzioni del servizio.",
        IC_SuperAdminCTA: "Vai al Centro amministrativo",
        IC_AdminTitle: "Attenzione",
        IC_AdminExpiredCardMessage: "Il metodo di pagamento associato alla tua licenza sta per scadere.",
        IC_AdminPaymentDueMessage: "Non siamo riusciti a elaborare il pagamento per la tua licenza, per evitare interruzioni del servizio ",
        IC_AdminExpiredCardCTA: "Fai clic qui per informare il tuo Super Admin.",
        IC_AdminPaymentDueCTA: "fai clic qui per notificare il tuo Super Admin.",
        IC_NotifTitle: "Attenzione richiesta",
        IC_NotifMessage: "Accedi a {appName} per aggiornamenti importanti",
        IC_SuccesNotifTitle: "Successo",
        IC_SuccesNotifMessage: "La notifica è stata inviata con successo al tuo Super Admin.",
        PreventUnlockPremiumFeaturesOnMobile: "Per eseguire l'upgrade a Premium/Platinum, utilizza Teams su desktop o web.",
        GoToAdminCenter: "Vai al Centro Amministrativo",
        PremiumMessage1: "Stai utilizzando una versione premium di {appTitle}.",
        ClickHere: "Clicca qui 🚀",
        PremiumMessage2: "per passare a Platinum e gestire le autorizzazioni in modo più efficace!",
        DiscardMessageTitle: "Modifiche non salvate",
        DiscardChanges: "Rimuovi",
        ContinueEditing: "Continua la modifica",
        DiscardMessage: "Vuoi continuare ad apportare modifiche o rimuoverle ?",
        VisitLink: "Visita il link",
        SelectCustomize: "Per personalizzare i permessi, seleziona 'Personalizza permessi' in alto",
        SaveBeforeSearch: "Salva le tue modifiche prima di cercare",
        AccessMaster: "Questo utente ha accesso alla password principale",
        FeaturesNowAvailable: "Goditi tutte le tue nuove funzionalità ora!",
        KnowAboutFeatures: "Per saperne di più sulle funzionalità disponibili, clicca <a target='_blank' href='{link}'>qui</a>!",
        Go: "Andiamo!",
        NeedToBuyLicences: "Devi acquistare delle licenze",
        HaveLicencesButNotEnough: "Hai già alcune licenze, ma sono tutte assegnate. Devi acquistare altre licenze per assegnarne una a te stesso.",
        BuyMoreLicence: "Acquista più licenze",
        GeneralPermissionsSettings: "Impostazioni delle autorizzazioni generali",
        CustomizedPermissionsSettings: "Impostazioni delle autorizzazioni personalizzate",
        About: "Informazioni",
        ReviewTitleJoin: "Unisciti a migliaia di utenti che amano {appName}!",
        ReviewSubtitleShare: "Aiuta altri a scoprire l'app condividendo la tua esperienza",
        ReviewQuote: "Le migliori app nascono dal feedback degli utenti",
        ThanksForYourRating: "Grazie per la tua valutazione",
        ReviewFeedbackQuestion: "Ci piacerebbe avere il tuo feedback! Ci vogliono solo due minuti.",
        WhatCouldWeImprove: "Cosa potremmo migliorare? 💭",
        SubmitMyFeedback: "Invia il mio feedback",
        FillCompleteFeedbackForm: "Compila il nostro modulo di feedback completo",
        MaybeLater: "Forse più tardi",
        ReviewOnAppSource: "Valutazione su AppSource",
        Version: "Versione",
        UniqueID: "Identificatore univoco",
        Copied: "Copiato!",
        Copy: "Copia",
        CreatedBy: "Creato da",
        SuggestFeature: "Suggerisci una funzione",
        HelpCenter: "Centro assistenza",
        MoreApps: "Altre app",
        "Sync:NoUrlErrorMessage": "Si prega di compilare questo campo con un link ics valido",
        "Sync:NoNameErrorMessage": "Si prega di aggiungere un nome a questo calendario",
        "Sync:StartUrlErrorMessage": 'Si prega di inserire un link ics valido, dovrebbe iniziare con "https://"',
        "Sync:EndUrlErrorMessage": 'Si prega di inserire un link ics valido, dovrebbe terminare con ".ics"',
        no_reason: "Non ho più bisogno dell'app",
        technical_issue: "Problemi tecnici o bug",
        bad_interface: "Difficile da usare o capire",
        limited_features: "Funzionalità limitate o insufficienti",
        switching_to_another_app: "Sto passando a un'altra soluzione",
        temporary_uninstallation: "Disinstallazione temporanea (potrei tornare)",
        UninstallReason: "Motivo",
        UninstallComment: "Commento",
        "Rte:StartUrlErrorMessage": 'Inserisci un link valido, deve iniziare con "https://"',
        "Rte:InsertLink": "Inserisci link",
        "Rte:TextToDisplay": "Testo da visualizzare",
        "Rte:Address": "Indirizzo",
        "Rte:AddressPlaceholder": "Link a una pagina web esistente",
        "Rte:NoHighlight": "Nessun evidenziamento",
        "Rte:ByDefault": "Per impostazione predefinita",
        "Rte:Large": "Grande",
        "Rte:Medium": "Medio",
        "Rte:InsertImageLink": "Inserisci il link dell'immagine",
        "Rte:ImageAddressPlaceholder": "Link a un'immagine esistente sul web",
        UnlockPlatinum: "Sblocca Platinum",
        UpgradePlatinumDescription: "Passa a Platinum per il tuo team. Gestisci i permessi utente e accedi a funzionalità avanzate pensate per gli amministratori.",
        AdvancedTeamManagement: "Gestione avanzata del team",
        ControlUserPermissions: "Controlla i permessi e i livelli di accesso degli utenti",
        PlatinumFeatures: "Funzionalità Platinum",
        AccessAllPlatinumTools: "Accedi a tutti gli strumenti e capacità Platinum",
        UnlockPremium: "Sblocca Premium",
        CalendarUpgradePremiumDescription: "Passa a Premium per il tuo team. Pianifica eventi ricorrenti, organizzali e condividi il tuo calendario.",
        CalendarPremiumRecurrence: "Eventi ricorrenti",
        CalendarPremiumRecurrenceDescription: "Ripeti i tuoi eventi ogni giorno, settimana o mese",
        CalendarPremiumOrganize: "Tag ed emoji",
        CalendarPremiumOrganizeDescription: "Organizza e metti in risalto i tuoi eventi",
        CalendarPremiumShare: "Condivisione e stampa",
        CalendarPremiumShareDescription: "Condividi i tuoi eventi e stampa il tuo calendario",
        PrioritySupport: "Supporto prioritario",
        DedicatedAssistance: "Assistenza dedicata",
        LearnMoreFeatures: "Scopri di più sulle funzionalità",
        "CookieDialogAnswer": "Rendi {appName} il tuo strumento migliore",
        "Experience": "Migliora la mia esperienza:",
        "ExperienceDesc": "Ottimizza le prestazioni, risolvi i bug più velocemente e dai priorità alle funzionalità che usi di più.",
        "Offer": "Ricevi offerte personalizzate:",
        "OfferDesc": "Suggerimenti, aggiornamenti e promozioni su misura per il tuo utilizzo. Niente spam. Puoi annullare l'iscrizione in qualsiasi momento.",
        "AcceptAll": "Accetta tutto",
        "Consent_Title": "Ottieni di più da {appName} ✨",
        "Consent_Subtitle": "Consigli e offerte sul prodotto via e-mail, più statistiche d'uso che ci aiutano a migliorare {appName}. Facoltativo e disattivato di default. Modificabile quando vuoi.",
        "Consent_Footer": "Queste scelte non toccano mai i tuoi dati in {appName}. Ciò che crei nell'app non viene condiviso e non è mai usato per il marketing.",
        "Consent_TrustRow": "Di Witivio · partner Microsoft · Annulla l'iscrizione quando vuoi",
        "Consent_Marketing": "Inviami consigli e offerte via e-mail",
        "Consent_MarketingDesc": "Circa una volta al mese: consigli, novità e offerte sul prodotto. Annulla l'iscrizione con un clic, quando vuoi.",
        "Consent_Experience": "Aiuta a migliorare {appName}",
        "Consent_ExperienceDesc": "Condividi come usi {appName}, così correggiamo i bug più in fretta e sviluppiamo le funzionalità che usi di più. Mai il contenuto che crei nell'app.",
        "Consent_EnableAll": "Accetta tutto ✨",
        "Consent_Customize": "Personalizza",
        "Consent_Save": "Salva le mie scelte",
        "Consent_Cancel": "Annulla",
        "Consent_Saved": "Salvato ✅ Ecco cosa hai attivato:",
        "Consent_Declined": "Tutto a posto. Non viene condiviso nulla.",
        "Consent_ResultMarketing": "• Consigli e offerte via e-mail",
        "Consent_ResultExperience": "• Statistiche per migliorare il prodotto",
        "Consent_ManageHint": "Modificabile in qualsiasi momento dal menu della barra degli strumenti: Preferenze privacy.",
        "Consent_PrivacyMenu": "Preferenze privacy",
        "ConsentScreen_Title": "Un ultimo passaggio prima di iniziare",
        "ConsentScreen_Subtitle": "Questa app funziona con il tuo account Microsoft 365. Consenti l'accesso una sola volta ed è tutto pronto.",
        "ConsentScreen_Allow": "Consenti l'accesso",
        "ConsentScreen_Waiting": "In attesa di Microsoft…",
        "ConsentScreen_Finishing": "Configurazione in corso…",
        "ConsentScreen_TryAgain": "Riprova",
        "ConsentScreen_Hint": "Si apre una finestra Microsoft per confermare. La tua password non viene mai condivisa con l'app.",
        "ConsentScreen_Revoke": "Puoi rimuovere questo accesso in qualsiasi momento da {link}.",
        "ConsentScreen_FailedTitle": "Accesso non concesso",
        "ConsentScreen_FailedText": "La finestra Microsoft si è chiusa prima che l'accesso fosse consentito. Se indicava \"Approvazione dell'amministratore necessaria\", solo un amministratore IT può approvare l'app: inviagli il link qui sotto.",
        "ConsentScreen_AdminToggle": "Serve l'approvazione dell'amministratore?",
        "ConsentScreen_AdminText": "Invia questo link al tuo amministratore IT. Una volta approvato, l'accesso è concesso a tutta la tua organizzazione.",
        "ConsentScreen_CopyLink": "Copia link",
        "ConsentScreen_Copied": "Link copiato",
        "ConsentScreen_LinkLabel": "Link di approvazione amministratore",
        "OnboardingTour:MenuEntry": "Tour guidato",
        "OnboardingTour:HowToUse": "Come si usa",
        "OnboardingTour:Step": "{current} di {total}",
        "OnboardingTour:Start": "Inizia il tour",
        "OnboardingTour:Next": "Avanti",
        "OnboardingTour:Back": "Indietro",
        "OnboardingTour:Skip": "Salta",
        "OnboardingTour:Done": "Ho capito",
    },
    es: {
        SendMessage: "Enviar mensaje",
        Call: "Llamar",
        System: "Sistema",
        Unknown: "Desconocido",
        TokenExpired: "Token expirado",
        PleaseRefreshTab: "Por favor, actualice la pestaña",
        AnErrorOccured: "Se produjo un error",
        Consent: "Consentimiento",
        NeedToConsent: "Debe dar su consentimiento",
        ClickButtonToContinue: "Haga clic en el botón para continuar",
        SearchATeam: "Buscar un equipo",
        JoinTeam: "Unirse al equipo",
        Teams: "Equipos",
        EditTextConfirm: "Guardar",
        EditTextEdit: "Editar",
        EditTextRemove: "Eliminar",
        EditTextLink: "Enlace",
        UnlockPremiumFeatures: "Desbloquear funciones Premium",
        UpgradePremium: "Actualizar a Premium",
        UpgradePlatinum: "Actualizar a Platinum",
        Cancel: "Cancelar",
        Insert: "Insertar",
        ThanksPurchase: "Gracias por su compra",
        PremiumNowAvailable: "Ahora puede disfrutar de todas las funciones premium",
        ManageLicences: "Gestionar licencias",
        Close: "Cerrar",
        RequestAccess: "Solicitar acceso",
        UpgradeTeamMessage: "Active la versión Premium para su equipo. Tendrá la capacidad de gestionar los miembros que tendrán acceso a la versión Premium.",
        UpgradePlatinumTeamMessage: "Active la versión Platinum para su equipo. Tendrá la capacidad de gestionar los miembros que tendrán acceso a la versión Platinum.",
        TeamHasLicences: "Su empresa ya tiene acceso a la versión Premium. Envíe un mensaje al administrador para solicitar acceso.",
        NoPremiumAccess: "No tiene acceso Premium",
        TeamHasPlatinumLicences: "Su empresa ya tiene acceso a la versión Platinum. Envíe un mensaje al administrador para solicitar acceso.",
        NoPlatinumAccess: "No tiene acceso Platinum",
        RequestAccessMessage: "Deje un mensaje al administrador para su solicitud de acceso. Será notificado y se le otorgará acceso pronto.",
        Send: "Enviar",
        AdministratorNotified: "Se ha notificado al administrador. Recibirá un correo electrónico cuando se apruebe su solicitud.",
        DefaultRequestMessage: "Hola, soy {userName} y me gustaría tener acceso a la versión Premium de {appTitle}. Gracias.",
        RequestAccessInApprobation: "Se está procesando una solicitud de acceso. Si tiene prisa, active el Premium ahora",
        "RequestAccess:Title": "Solicitar acceso a {appTitle}",
        "RequestAccess:Subtitle": "Su organización ya está suscrita a esta aplicación: un administrador solo tiene que asignarle una licencia.",
        "RequestAccess:Step1": "Sus administradores reciben su solicitud por correo electrónico",
        "RequestAccess:Step2": "Uno de ellos le asigna una licencia",
        "RequestAccess:Step3": "Recibe un correo electrónico en cuanto su acceso esté activo",
        "RequestAccess:MessageLabel": "Mensaje para sus administradores",
        "RequestAccess:Send": "Enviar solicitud",
        "RequestAccess:Pending": "Ya tiene una solicitud pendiente de aprobación. Recibirá un correo electrónico en cuanto un administrador responda.",
        "RequestAccess:Failed": "No se ha podido enviar su solicitud. Inténtelo de nuevo en un momento.",
        "Permissions:Title": "Permisos",
        "Page:Back": "Volver",
        "Premium:LicenceHint": "Buenas noticias: su organización ya tiene licencias de {appTitle}. Pida a su administrador que le asigne una.",
        "Premium:RequestLicence": "Solicitar una licencia a mi administrador",
        "AdminLicence:Badge": "Administrador",
        "AdminLicence:Title": "Asígnate una licencia {plan}",
        "AdminLicence:Subtitle": "Tu organización ya tiene licencias de {appTitle} disponibles. Como administrador, puedes asignarte una en pocos clics, sin ninguna compra.",
        "AdminLicence:Hint": "Desde la misma página también puedes asignar licencias a tus compañeros.",
        "AdminLicence:Assign": "Asignarme una licencia",
        "Page:UpgradeCta": "Mejorar plan",
        "SaveBar:Unsaved": "Tienes cambios sin guardar",
        "SaveBar:Discard": "Descartar",
        "SaveBar:Save": "Guardar cambios",
        "SaveBar:Saved": "Cambios guardados.",
        "SaveBar:Failed": "No se pudieron guardar tus cambios. Inténtalo de nuevo.",
        "Permissions:Subtitle": "Elige quién puede añadir, modificar y eliminar {taskName}.",
        "Permissions:ModeTitle": "Quién puede hacer cambios",
        "Permissions:ModeEveryoneTitle": "Todos",
        "Permissions:ModeEveryoneBody": "Cada miembro del canal puede añadir, modificar y eliminar {taskName}.",
        "Permissions:ModeOwnersTitle": "Solo los propietarios",
        "Permissions:ModeOwnersBody": "Los miembros ven {taskName}; solo los propietarios de {appTitle} pueden modificarlos.",
        "Permissions:ModeCustomTitle": "Personalizado",
        "Permissions:ModeCustomBody": "Elige, miembro por miembro, quién puede añadir, modificar y eliminar {taskName}.",
        "Permissions:CustomHint": "Elige Personalizado para definir los derechos de cada miembro.",
        "Permissions:ReadOnly": "Solo los propietarios pueden cambiar los permisos. Aquí puedes consultarlos.",
        "Permissions:UpgradeTitle": "Los permisos personalizados vienen con Platinum",
        "Permissions:UpgradeBody": "Decide miembro por miembro quién puede añadir, modificar y eliminar {taskName}.",
        "Permissions:LicencePremium": "Premium",
        "Permissions:LicenceFree": "Gratis",
        "Permissions:MakeOwner": "Hacer propietario",
        "Permissions:You": "Tú",
        "Permissions:Loading": "Cargando miembros…",
        "Permissions:NoMatch": "Ningún miembro coincide con “{search}”.",
        "Permissions:NoMembers": "Aún no hay miembros",
        "Permissions:NoMembersBody": "Añade miembros para darles sus propios derechos.",
        "Permissions:PageInfo": "{from}–{to} de {total}",
        "Permissions:PreviousPage": "Página anterior",
        "Permissions:NextPage": "Página siguiente",
        "Permissions:MembersTitle": "Miembros ({count})",
        "Permissions:AddMembers": "Añadir miembros",
        "Permissions:LockedWhileDirty": "Guarda o descarta tus cambios para buscar o cambiar de página.",
        "Sync:Subtitle": "Muestra tus calendarios de Outlook, Google u otros en {app}, y sigue {app} desde otras aplicaciones de calendario.",
        "Sync:SubtitleResource": "Sigue {app} desde Outlook, Google Calendar o cualquier otra aplicación de calendario.",
        "Sync:ExternalTitle": "Calendarios externos ({count}/{max})",
        "Sync:ExternalHint": "Se actualizan cada 15 minutos. Solo tú los ves, salvo que los compartas.",
        "Sync:MaxReached": "Puedes sincronizar hasta {max} calendarios.",
        "Sync:EmptyTitle": "Aún no hay calendarios externos",
        "Sync:EmptyBody": "Pega el enlace .ics de un calendario de Outlook o Google para ver sus eventos en {app}.",
        "Sync:NewCalendar": "nuevo calendario",
        "Sync:NameLabel": "Nombre",
        "Sync:NamePlaceholder": "Ej.: Vacaciones del equipo",
        "Sync:UrlLabel": "Enlace .ics",
        "Sync:UrlPlaceholder": "https://…/calendar.ics",
        "Sync:UrlHelp": "Empieza por https:// y termina en .ics",
        "Sync:ColorLabel": "Color",
        "Sync:StatusNew": "Aún sin guardar",
        "Sync:StatusChecking": "Comprobando…",
        "Sync:StatusIssue": "Problema de conexión",
        "Sync:ShareToggle": "Mostrarlo a los demás miembros de {app}",
        "Sync:Remove": "Quitar",
        "Sync:RemoveConfirm": "¿Quitar “{name}”? Sus eventos desaparecerán de tu vista.",
        "Sync:PublishTitle": "Seguir {app} desde otra aplicación",
        "Sync:PublishBody": "Suscríbete a esta dirección desde Outlook, Google Calendar o cualquier aplicación que lea el formato iCal. Mantenla privada: cualquiera con el enlace ve tus eventos.",
        "Sync:PublishLocked": "Disponible con Platinum",
        "Sync:Copy": "Copiar enlace",
        "Sync:Copied": "Copiado",
        "Sync:FixErrors": "Completa los campos marcados para guardar.",
        "Sync:UpgradeTitle": "La sincronización de calendarios viene con Platinum",
        "Sync:UpgradeBody": "Trae hasta 3 calendarios externos a {app} y síguelo desde otras aplicaciones de calendario.",
        "Permissions:Search": "Buscar miembros",
        "Permissions:TableName": "Nombre",
        "Permissions:TableRole": "Rol",
        "Reminds:Permissions:Tableadd": "Agregar",
        "Reminds:Permissions:Tableupdate": "Modificar",
        "Reminds:Permissions:Tabledelete": "Eliminar",
        "Calendar:Permissions:Tableadd": "Agregar",
        "AiCalendar:Permissions:Tableadd": "Agregar",
        "Calendar:Permissions:Tableupdate": "Modificar",
        "AiCalendar:Permissions:Tableupdate": "Modificar",
        "Calendar:Permissions:Tabledelete": "Eliminar",
        "AiCalendar:Permissions:Tabledelete": "Eliminar",
        "Calendar:Permissions:TableallowShareSynchro": "Compartir calendario",
        "AiCalendar:Permissions:TableallowShareSynchro": "Compartir calendario",
        "Calendar:Permissions:TableallowEditMeetingScheduler": "Plataforma de programación de reuniones",
        "Booking:Permissions:Tableadd": "Agregar",
        "Booking:Permissions:Tableupdate": "Modificar",
        "Booking:Permissions:Tabledelete": "Eliminar",
        "Parking:Permissions:Tableadd": "Agregar",
        "Parking:Permissions:Tableupdate": "Modificar",
        "Parking:Permissions:Tabledelete": "Eliminar",
        "Contact:Permissions:Tableadd": "Agregar",
        "Contact:Permissions:Tableupdate": "Modificar",
        "Contact:Permissions:Tabledelete": "Eliminar",
        "Keepass:Permissions:Tableadd": "Agregar",
        "Keepass:Permissions:Tableupdate": "Modificar",
        "Keepass:Permissions:Tabledelete": "Eliminar / Restaurar",
        "Permissions:CancelButton": "Cancelar",
        "Permissions:SaveButton": "Guardar",
        "Permissions:AddMemberButton": "Agregar miembro",
        "Permissions:GeneralSetting": "Configuración general",
        "Reminds:Permissions:addInfo": "El usuario podrá agregar recordatorios",
        "Reminds:Permissions:updateInfo": "El usuario podrá modificar recordatorios",
        "Reminds:Permissions:deleteInfo": "El usuario podrá eliminar recordatorios",
        "Calendar:Permissions:addInfo": "El usuario podrá agregar eventos",
        "AiCalendar:Permissions:addInfo": "El usuario podrá agregar eventos",
        "Calendar:Permissions:updateInfo": "El usuario podrá modificar eventos",
        "AiCalendar:Permissions:updateInfo": "El usuario podrá modificar eventos",
        "Calendar:Permissions:deleteInfo": "El usuario podrá eliminar eventos",
        "AiCalendar:Permissions:deleteInfo": "El usuario podrá eliminar eventos",
        "Calendar:Permissions:allowEditMeetingSchedulerInfo": "El usuario podrá gestionar la configuración de la plataforma de programación de reuniones",
        "Calendar:Permissions:allowShareSynchroInfo": "El usuario podrá compartir sus calendarios sincronizados con todos",
        "AiCalendar:Permissions:allowShareSynchroInfo": "El usuario podrá compartir sus calendarios sincronizados con todos",
        "Booking:Permissions:addInfo": "El usuario podrá agregar reservas",
        "Booking:Permissions:updateInfo": "El usuario podrá modificar reservas",
        "Booking:Permissions:deleteInfo": "El usuario podrá eliminar reservas",
        "Parking:Permissions:addInfo": "El usuario podrá agregar reservas",
        "Parking:Permissions:updateInfo": "El usuario podrá modificar reservas",
        "Parking:Permissions:deleteInfo": "El usuario podrá eliminar reservas",
        "Contact:Permissions:addInfo": "El usuario podrá añadir contactos y grupos",
        "Contact:Permissions:updateInfo": "El usuario podrá modificar contactos y grupos",
        "Contact:Permissions:deleteInfo": "El usuario podrá eliminar contactos y grupos",
        "Keepass:Permissions:addInfo": "El usuario podrá añadir contraseñas",
        "Keepass:Permissions:updateInfo": "El usuario podrá modificar contraseñas",
        "Keepass:Permissions:deleteInfo": "El usuario podrá eliminar y restaurar contraseñas",
        "Permissions:Owner": "Propietario",
        "Permissions:Admin": "Administrador",
        "Permissions:Member": "Miembro",
        "Permissions:MemberIsNotPlatinum": "Personalización reservada para suscriptores Platinum",
        "Permissions:EveryoneDropdown": "Todos en este canal pueden agregar/editar/eliminar {taskName}",
        "Permissions:CreatorDropdown": "Solo el/los propietario(s) de {appTitle} puede agregar/editar/eliminar {taskName}",
        "Permissions:CustomDropdown": "Personalizar permisos",
        "Permissions:Platinum": "Platinum",
        "Permissions:Premium": "<a href='https://admin.teams-pro.com/users' target='_blank'>Premium</a>",
        "Permissions:Free": "<a href='https://admin.teams-pro.com/users' target='_blank'>Gratis</a>",
        "Permissions:AssignLicense": "Haga clic para asignar una licencia Platinum 🚀",
        "Permissions:Subscription": "Suscripción",
        AddMembers: "Agregar miembros",
        AddMembersTagLine: "Ingrese el correo electrónico de la persona que desea agregar",
        EmailAddress: "Ingrese una dirección de correo electrónico",
        SaveAlert: "¡Sus cambios se han guardado exitosamente!",
        CancelTagLine: "Si continúa ahora, se perderán todos los cambios que haya realizado. ¿Está seguro de que desea continuar?",
        Continue: "Continuar",
        Return: "Volver",
        "Permissions:FreeRedirect": "Está utilizando una versión gratuita de {appTitle}.",
        "Permissions:PremiumRedirect": "Está utilizando una versión premium de {appTitle}.",
        "Booking:taskName": "reservas",
        "Parking:taskName": "reservas",
        "Reminds:taskName": "recordatorios",
        "Calendar:taskName": "eventos",
        "AiCalendar:taskName": "eventos",
        "Contact:taskName": "contactos y grupos",
        "Gantt:taskName": "tareas",
        "Keepass:taskName": "contraseñas",
        "Sync:PremiumRedirect": "Está utilizando una versión premium de Calendar Pro. Cambiar a la versión Platinum 🚀 y gestionar las sincronizaciones.",
        "Sync:FreeRedirect": "Está utilizando una versión gratuita de Calendar Pro. Cambiar a la versión Platinum 🚀 y gestionar las sincronizaciones.",
        NotAllowed: "No tiene permitido cambiar los permisos.",
        NotAllowedNotif: "No tiene permitido cambiar esta configuración.",
        CancelModifications: "Cancelar modificaciones",
        "Sync:Title": "Sincronizar calendarios",
        "Sync:Manage": "Gestionar",
        "Sync:Synchronize": "Sincronizar",
        "Sync:Add": "Agregar calendario",
        "Sync:SyncCalendarTitle": "Sincronizar mi calendario con ",
        "Sync:ShareTitle": "Compartir mi ",
        "Sync:CalendarName": "Nombre del calendario",
        "Sync:ICSLink": "Enlace ICS del calendario",
        "Sync:PublicAddress": "Dirección pública en formato iCal",
        "Sync:TableName": "Nombre",
        "Sync:TableColor": "Color",
        "Sync:TableShow": "Compartir",
        "Sync:TableState": "Estado",
        "Sync:SynchronizeLine": "Para administrar todos sus calendarios en un solo lugar, sincronice su calendario.",
        "Sync:SyncCalendarTooltip": "Puede sincronizar un máximo de 3 calendarios. Su calendario se sincronizará cada 15 minutos.",
        "Sync:SyncTitle": "Agregar sus calendarios externos",
        AddAlert: "Los miembros se han agregado correctamente",
        "Sync:ICSInput": "Ingrese una URL",
        "Sync:NameInput": "Ingrese un nombre",
        "Sync:TableAction": "Acción",
        "Sync:ManageTooltip": "No tiene calendarios sincronizados",
        AddressTitle: "Dirección",
        AddAddress: "Ingrese una dirección",
        Participants: "Participantes",
        NoParticipants: "Sin resultados",
        "Sync:TabTooltip": "Debe guardar/cancelar sus cambios",
        "Sync:DeleteCalendar": "Eliminar calendario",
        "Sync:DeleteTagLine": "Si continúa ahora, su calendario se eliminará de su vista. Para verlo nuevamente, deberá sincronizarlo nuevamente.",
        "Sync:NotAllowToShare": "El propietario del calendario no le ha permitido compartir sus calendarios con otros usuarios",
        "Sync:ConnectionIssue": "Se ha detectado un problema de conexión con el calendario. Verifique la existencia del calendario y el estado de la conexión para una sincronización sin problemas.",
        "Permissions:CreatorRole": "Propietario de este calendario",
        Synchronized: "Sincronizado",
        Unsynchronized: "No sincronizado",
        "Sync:UnsynchronizedTooltip": "Se ha detectado un problema de conexión con el calendario. Verifique la existencia del calendario y el estado de la conexión para una sincronización sin problemas.",
        "Sync:ShareInfo": "Comparta este calendario con los miembros de ",
        AddParticipantsButton: "Agregar participantes",
        "Sync:getErrorMessage": "Se produjo un error con su enlace ICS en el calendario: ",
        "Permissions:ManageRoleTitle": "Confirmación del cambio de rol",
        "Permissions:ManageRoleTagLine": "Está a punto de cambiar el rol de un miembro. Esto otorgará permisos que no podrá quitarle a un miembro. ¿Está seguro de que desea continuar?",
        NotifDialogHeader: "Configuración de notificaciones de Teams",
        RedirectToAppSource: "<p style='text-align: center;'>Será redirigido al Microsoft Marketplace. Si no es redirigido, <a target='_blank' href='{link}'>haga clic aquí</a>.</a>",
        WhatsNewsOn: "Novedades",
        NewsSoon: "¡Próximamente novedades!",
        NeedConsentTitle: "Se requiere consentimiento",
        NeedConsent: "Para utilizar esta función, se requieren permisos adicionales. Si acepta, se lo redirigirá a la página de consentimiento.",
        NoAddress: "No se encontraron resultados en Google Maps",
        YourInfo: "Tus información",
        ChooseTime: "Elegir fecha y hora",
        IC_SuperAdminTitle: "Atención",
        IC_SuperAdminExpiredCardMessage: "Su información de pago está a punto de caducar. Por favor, actualícela para evitar una interrupción del servicio.",
        IC_SuperAdminPaymentDueMessage: "Tu cuenta tiene facturas pendientes. Por favor, págalas para evitar la interrupción del servicio.",
        IC_SuperAdminCTA: "Ir al Centro de administración",
        IC_AdminTitle: "Atención",
        IC_AdminExpiredCardMessage: "El método de pago asociado a su licencia está a punto de expirar.",
        IC_AdminPaymentDueMessage: "No pudimos procesar el pago de su licencia, para evitar la interrupción del servicio ",
        IC_AdminExpiredCardCTA: "Haga clic aquí para informar a su Super Admin.",
        IC_AdminPaymentDueCTA: "haga clic aquí para notificar a su Super Admin.",
        IC_NotifTitle: "Atención requerida",
        IC_NotifMessage: "Acceda a {appName} para obtener actualizaciones importantes",
        IC_SuccesNotifTitle: "Éxito",
        IC_SuccesNotifMessage: "La notificación se ha enviado correctamente a su Super Admin.",
        PreventUnlockPremiumFeaturesOnMobile: "Para actualizar a la versión Premium/Platinum, utilice Teams en el escritorio o en la web.",
        GoToAdminCenter: "Ir al Centro de administración",
        PremiumMessage1: "Estás utilizando una versión premium de {appTitle}.",
        ClickHere: "Haz clic aquí 🚀",
        PremiumMessage2: "para actualizar a Platinum y gestionar permisos de manera más efectiva!",
        DiscardMessageTitle: "Cambios no guardados",
        DiscardChanges: "Descartar",
        ContinueEditing: "Continuar la edición",
        DiscardMessage: "¿Deseas descartar las modificaciones o continuar con la edición?",
        VisitLink: "Visitar el enlace",
        SelectCustomize: "Para personalizar los permisos, selecciona 'Personalizar permisos' arriba",
        SaveBeforeSearch: "Guarda tus cambios antes de buscar",
        AccessMaster: "Este usuario tiene acceso a la contraseña maestra",
        FeaturesNowAvailable: "¡Disfruta de todas tus nuevas características ahora!",
        KnowAboutFeatures: "Para saber más sobre las funciones disponibles para ti, haz clic <a target='_blank' href='{link}'>aquí</a>!",
        Go: "¡Vamos!",
        NeedToBuyLicences: "Necesitas comprar licencias",
        HaveLicencesButNotEnough: "Ya tienes algunas licencias, pero todas están asignadas. Debes comprar más licencias para asignarte una a ti mismo.",
        BuyMoreLicence: "Comprar más licencias",
        GeneralPermissionsSettings: "Configuración general de permisos",
        CustomizedPermissionsSettings: "Configuración personalizada de permisos",
        About: "Acerca de",
        ReviewTitleJoin: "¡Únete a miles de usuarios que aman {appName}!",
        ReviewSubtitleShare: "Ayuda a otros a descubrir la aplicación compartiendo tu experiencia",
        ReviewQuote: "Las mejores aplicaciones nacen del feedback de los usuarios",
        ThanksForYourRating: "Gracias por tu valoración",
        ReviewFeedbackQuestion: "¡Nos encantaría conocer tu opinión! Solo lleva dos minutos.",
        WhatCouldWeImprove: "¿Qué podríamos mejorar? 💭",
        SubmitMyFeedback: "Enviar mi feedback",
        FillCompleteFeedbackForm: "Rellenar nuestro formulario de feedback completo",
        MaybeLater: "Quizás más tarde",
        ReviewOnAppSource: "Valorar en AppSource",
        Version: "Versión",
        UniqueID: "Identificador único",
        Copied: "Copiado!",
        Copy: "Copiar",
        CreatedBy: "Creado por",
        SuggestFeature: "Sugerir una característica",
        HelpCenter: "Centro de ayuda",
        MoreApps: "Más aplicaciones",
        "Sync:NoUrlErrorMessage": "Por favor, complete este campo con un enlace ics válido",
        "Sync:NoNameErrorMessage": "Por favor, añada un nombre a este calendario",
        "Sync:StartUrlErrorMessage": 'Por favor, introduzca un enlace ics válido, debería comenzar con "https://"',
        "Sync:EndUrlErrorMessage": 'Por favor, introduzca un enlace ics válido, debería terminar con ".ics"',
        no_reason: "Ya no necesito la aplicación",
        technical_issue: "Problemas técnicos o errores",
        bad_interface: "Difícil de usar o entender",
        limited_features: "Funciones limitadas o insuficientes",
        switching_to_another_app: "Estoy cambiando a otra solución",
        temporary_uninstallation: "Desinstalación temporal (podría volver)",
        UninstallReason: "Razón",
        UninstallComment: "Comentario",
        "Rte:StartUrlErrorMessage": 'Por favor, introduce un enlace válido, debe empezar por "https://"',
        "Rte:InsertLink": "Insertar enlace",
        "Rte:TextToDisplay": "Texto a mostrar",
        "Rte:Address": "Dirección",
        "Rte:AddressPlaceholder": "Enlace a una página web existente",
        "Rte:NoHighlight": "Sin resaltar",
        "Rte:ByDefault": "Por defecto",
        "Rte:Large": "Grande",
        "Rte:Medium": "Mediano",
        "Rte:InsertImageLink": "Insertar enlace de imagen",
        "Rte:ImageAddressPlaceholder": "Enlace a una imagen existente en la web",
        UnlockPlatinum: "Desbloquear Platinum",
        UpgradePlatinumDescription: "Actualiza a Platinum para tu equipo. Gestiona permisos de usuario y accede a funciones avanzadas para administradores.",
        AdvancedTeamManagement: "Gestión avanzada de equipos",
        ControlUserPermissions: "Controla los permisos y niveles de acceso de los usuarios",
        PlatinumFeatures: "Funciones Platinum",
        AccessAllPlatinumTools: "Accede a todas las herramientas y capacidades Platinum",
        UnlockPremium: "Desbloquear Premium",
        CalendarUpgradePremiumDescription: "Actualiza a Premium para tu equipo. Planifica eventos recurrentes, organízalos y comparte tu calendario.",
        CalendarPremiumRecurrence: "Eventos recurrentes",
        CalendarPremiumRecurrenceDescription: "Repite tus eventos cada día, semana o mes",
        CalendarPremiumOrganize: "Etiquetas y emoji",
        CalendarPremiumOrganizeDescription: "Organiza y destaca tus eventos",
        CalendarPremiumShare: "Compartir e imprimir",
        CalendarPremiumShareDescription: "Comparte tus eventos e imprime tu calendario",
        PrioritySupport: "Soporte prioritario",
        DedicatedAssistance: "Asistencia dedicada",
        LearnMoreFeatures: "Más información sobre las funciones",
        "CookieDialogAnswer": "Haz de {appName} tu mejor herramienta",
        "Experience": "Mejora mi experiencia:",
        "ExperienceDesc": "Optimiza el rendimiento, soluciona errores más rápido y prioriza las funciones que usas más.",
        "Offer": "Recibe ofertas personalizadas:",
        "OfferDesc": "Sugerencias, actualizaciones y promociones adaptadas a tu uso. Sin spam. Puedes darte de baja en cualquier momento.",
        "AcceptAll": "Aceptar todo",
        "Consent_Title": "Saca más partido a {appName} ✨",
        "Consent_Subtitle": "Consejos y ofertas de producto por correo, además de estadísticas de uso que nos ayudan a mejorar {appName}. Opcional y desactivado por defecto. Puedes cambiarlo cuando quieras.",
        "Consent_Footer": "Estas opciones nunca afectan a tus datos en {appName}. Lo que creas en la aplicación no se comparte y nunca se usa con fines de marketing.",
        "Consent_TrustRow": "De Witivio · partner de Microsoft · Cancela cuando quieras",
        "Consent_Marketing": "Enviarme consejos y ofertas por correo",
        "Consent_MarketingDesc": "Una vez al mes, más o menos: consejos, novedades y ofertas de producto. Cancela la suscripción con un clic, cuando quieras.",
        "Consent_Experience": "Ayudar a mejorar {appName}",
        "Consent_ExperienceDesc": "Comparte cómo usas {appName} para que corrijamos errores más rápido y desarrollemos las funciones que más usas. Nunca el contenido que creas en la aplicación.",
        "Consent_EnableAll": "Aceptar todo ✨",
        "Consent_Customize": "Personalizar",
        "Consent_Save": "Guardar mis preferencias",
        "Consent_Cancel": "Cancelar",
        "Consent_Saved": "Guardado ✅ Esto es lo que has activado:",
        "Consent_Declined": "Listo. No se comparte nada.",
        "Consent_ResultMarketing": "• Consejos y ofertas por correo",
        "Consent_ResultExperience": "• Estadísticas para mejorar el producto",
        "Consent_ManageHint": "Puedes cambiarlo cuando quieras desde el menú de la barra de herramientas: Opciones de privacidad.",
        "Consent_PrivacyMenu": "Opciones de privacidad",
        "ConsentScreen_Title": "Un último paso antes de empezar",
        "ConsentScreen_Subtitle": "Esta aplicación funciona con su cuenta de Microsoft 365. Permita el acceso una sola vez y listo.",
        "ConsentScreen_Allow": "Permitir el acceso",
        "ConsentScreen_Waiting": "Esperando a Microsoft…",
        "ConsentScreen_Finishing": "Preparando todo…",
        "ConsentScreen_TryAgain": "Reintentar",
        "ConsentScreen_Hint": "Se abre una ventana de Microsoft para confirmar. Su contraseña nunca se comparte con la aplicación.",
        "ConsentScreen_Revoke": "Puede retirar este acceso en cualquier momento desde {link}.",
        "ConsentScreen_FailedTitle": "No se concedió el acceso",
        "ConsentScreen_FailedText": "La ventana de Microsoft se cerró antes de permitir el acceso. Si indicaba \"Se necesita la aprobación del administrador\", solo un administrador de TI puede aprobar la aplicación: envíele el enlace de abajo.",
        "ConsentScreen_AdminToggle": "¿Se necesita la aprobación del administrador?",
        "ConsentScreen_AdminText": "Envíe este enlace a su administrador de TI. Una vez aprobado, el acceso se concede a toda su organización.",
        "ConsentScreen_CopyLink": "Copiar enlace",
        "ConsentScreen_Copied": "Enlace copiado",
        "ConsentScreen_LinkLabel": "Enlace de aprobación del administrador",
        "OnboardingTour:MenuEntry": "Visita guiada",
        "OnboardingTour:HowToUse": "Cómo usarlo",
        "OnboardingTour:Step": "{current} de {total}",
        "OnboardingTour:Start": "Empezar la visita",
        "OnboardingTour:Next": "Siguiente",
        "OnboardingTour:Back": "Atrás",
        "OnboardingTour:Skip": "Omitir",
        "OnboardingTour:Done": "Entendido",
    },
    pt: {
        UnlockPremiumFeatures: "Desbloqueie o Premium para ativar mais recursos",
        UpgradePremium: "Atualizar para Premium",
        UpgradePlatinum: "Atualizar para Platinum",
        Cancel: "Cancelar",
        Insert: "Inserir",
        ThanksPurchase: "Obrigado pela sua compra",
        PremiumNowAvailable: "Agora você pode desfrutar de todos os recursos premium",
        ManageLicences: "Gerenciar licenças",
        Close: "Fechar",
        RequestAccess: "Solicitar acesso",
        UpgradeTeamMessage: "Atualize para Premium para sua própria equipe. Você poderá gerenciar os membros que terão acesso à versão Premium.",
        UpgradePlatinumTeamMessage: "Atualize para Platinum para sua própria equipe. Você poderá gerenciar os membros que terão acesso à versão Platinum.",
        TeamHasLicences: "Sua empresa já atualizou para Premium. Deixe uma mensagem para o administrador solicitar acesso.",
        NoPremiumAccess: "Você não tem acesso premium",
        TeamHasPlatinumLicences: "Sua empresa já atualizou para Platinum. Deixe uma mensagem para o administrador solicitar acesso.",
        NoPlatinumAccess: "Você não tem acesso Platinum",
        RequestAccessMessage: "Deixe uma mensagem para o administrador solicitar acesso. Será notificado e receberá acesso em breve.",
        Send: "Enviar",
        AdministratorNotified: "O administrador foi notificado. Você receberá um e-mail quando estiver pronto.",
        DefaultRequestMessage: "Olá, sou {userName} e gostaria de ter acesso Premium em {appTitle}. Obrigado.",
        RequestAccessInApprobation: "Uma solicitação de acesso está sendo aprovada. Se estiver com pressa, ative o Premium agora",
        "RequestAccess:Title": "Solicitar acesso a {appTitle}",
        "RequestAccess:Subtitle": "Sua organização já assina este aplicativo: um administrador só precisa atribuir uma licença a você.",
        "RequestAccess:Step1": "Seus administradores recebem sua solicitação por e-mail",
        "RequestAccess:Step2": "Um deles atribui uma licença a você",
        "RequestAccess:Step3": "Você recebe um e-mail assim que seu acesso estiver ativo",
        "RequestAccess:MessageLabel": "Mensagem para seus administradores",
        "RequestAccess:Send": "Enviar solicitação",
        "RequestAccess:Pending": "Você já tem uma solicitação aguardando aprovação. Você receberá um e-mail assim que um administrador responder.",
        "RequestAccess:Failed": "Não foi possível enviar sua solicitação. Tente novamente em instantes.",
        SendMessage: "Enviar mensagem",
        Call: "Ligar",
        System: "Sistema",
        Unknown: "Desconhecido",
        TokenExpired: "Token expirado",
        PleaseRefreshTab: "Por favor, atualize a aba",
        AnErrorOccured: "Ocorreu um erro",
        Consent: "Consentimento",
        NeedToConsent: "Precisa consentir",
        ClickButtonToContinue: "Clique no botão para continuar",
        SearchATeam: "Pesquisar uma equipe",
        JoinTeam: "Participar da equipe",
        Teams: "Equipes",
        EditTextConfirm: "Salvar",
        EditTextEdit: "Editar",
        EditTextRemove: "Remover",
        EditTextLink: "Link",
        "Permissions:Title": "Permissões",
        "Page:Back": "Voltar",
        "Premium:LicenceHint": "Boa notícia: sua organização já tem licenças do {appTitle}. Peça ao seu administrador para atribuir uma a você.",
        "Premium:RequestLicence": "Solicitar uma licença ao meu administrador",
        "AdminLicence:Badge": "Administrador",
        "AdminLicence:Title": "Atribua a si mesmo uma licença {plan}",
        "AdminLicence:Subtitle": "Sua organização já tem licenças do {appTitle} disponíveis. Como administrador, você pode atribuir uma a si mesmo em poucos cliques, sem nenhuma compra.",
        "AdminLicence:Hint": "Na mesma página, você também pode atribuir licenças aos seus colegas.",
        "AdminLicence:Assign": "Atribuir uma licença para mim",
        "Page:UpgradeCta": "Fazer upgrade",
        "SaveBar:Unsaved": "Você tem alterações não salvas",
        "SaveBar:Discard": "Descartar",
        "SaveBar:Save": "Salvar alterações",
        "SaveBar:Saved": "Alterações salvas.",
        "SaveBar:Failed": "Não foi possível salvar suas alterações. Tente novamente.",
        "Permissions:Subtitle": "Escolha quem pode adicionar, alterar e excluir {taskName}.",
        "Permissions:ModeTitle": "Quem pode fazer alterações",
        "Permissions:ModeEveryoneTitle": "Todos",
        "Permissions:ModeEveryoneBody": "Cada membro do canal pode adicionar, alterar e excluir {taskName}.",
        "Permissions:ModeOwnersTitle": "Somente proprietários",
        "Permissions:ModeOwnersBody": "Os membros veem {taskName}; somente os proprietários de {appTitle} podem alterá-los.",
        "Permissions:ModeCustomTitle": "Personalizado",
        "Permissions:ModeCustomBody": "Escolha, membro a membro, quem pode adicionar, alterar e excluir {taskName}.",
        "Permissions:CustomHint": "Escolha Personalizado para definir os direitos de cada membro.",
        "Permissions:ReadOnly": "Somente proprietários podem alterar as permissões. Você pode consultá-las aqui.",
        "Permissions:UpgradeTitle": "Permissões personalizadas vêm com o Platinum",
        "Permissions:UpgradeBody": "Decida membro a membro quem pode adicionar, alterar e excluir {taskName}.",
        "Permissions:LicencePremium": "Premium",
        "Permissions:LicenceFree": "Gratuito",
        "Permissions:MakeOwner": "Tornar proprietário",
        "Permissions:You": "Você",
        "Permissions:Loading": "Carregando membros…",
        "Permissions:NoMatch": "Nenhum membro corresponde a “{search}”.",
        "Permissions:NoMembers": "Ainda não há membros",
        "Permissions:NoMembersBody": "Adicione membros para lhes dar direitos próprios.",
        "Permissions:PageInfo": "{from}–{to} de {total}",
        "Permissions:PreviousPage": "Página anterior",
        "Permissions:NextPage": "Próxima página",
        "Permissions:MembersTitle": "Membros ({count})",
        "Permissions:AddMembers": "Adicionar membros",
        "Permissions:LockedWhileDirty": "Salve ou descarte suas alterações para pesquisar ou mudar de página.",
        "Sync:Subtitle": "Veja seus calendários do Outlook, Google ou outros no {app} e acompanhe o {app} em outros aplicativos de calendário.",
        "Sync:SubtitleResource": "Acompanhe o {app} no Outlook, Google Agenda ou qualquer outro aplicativo de calendário.",
        "Sync:ExternalTitle": "Calendários externos ({count}/{max})",
        "Sync:ExternalHint": "Atualizados a cada 15 minutos. Só você os vê, a menos que os compartilhe.",
        "Sync:MaxReached": "Você pode sincronizar até {max} calendários.",
        "Sync:EmptyTitle": "Ainda não há calendários externos",
        "Sync:EmptyBody": "Cole o link .ics de um calendário do Outlook ou Google para ver seus eventos no {app}.",
        "Sync:NewCalendar": "novo calendário",
        "Sync:NameLabel": "Nome",
        "Sync:NamePlaceholder": "Ex.: Férias da equipe",
        "Sync:UrlLabel": "Link .ics",
        "Sync:UrlPlaceholder": "https://…/calendar.ics",
        "Sync:UrlHelp": "Começa com https:// e termina com .ics",
        "Sync:ColorLabel": "Cor",
        "Sync:StatusNew": "Ainda não salvo",
        "Sync:StatusChecking": "Verificando…",
        "Sync:StatusIssue": "Problema de conexão",
        "Sync:ShareToggle": "Mostrar aos outros membros do {app}",
        "Sync:Remove": "Remover",
        "Sync:RemoveConfirm": "Remover “{name}”? Seus eventos vão sumir da sua visualização.",
        "Sync:PublishTitle": "Acompanhar o {app} em outro aplicativo",
        "Sync:PublishBody": "Assine este endereço no Outlook, Google Agenda ou qualquer aplicativo que leia o formato iCal. Mantenha-o privado: qualquer pessoa com o link vê seus eventos.",
        "Sync:PublishLocked": "Disponível com o Platinum",
        "Sync:Copy": "Copiar link",
        "Sync:Copied": "Copiado",
        "Sync:FixErrors": "Preencha os campos destacados para salvar.",
        "Sync:UpgradeTitle": "A sincronização de calendários vem com o Platinum",
        "Sync:UpgradeBody": "Traga até 3 calendários externos para o {app} e acompanhe-o em outros aplicativos de calendário.",
        "Permissions:Search": "Buscar membros",
        "Permissions:TableName": "Nome",
        "Permissions:TableRole": "Função",
        "Reminds:Permissions:Tableadd": "Adicionar",
        "Reminds:Permissions:Tableupdate": "Modificar",
        "Reminds:Permissions:Tabledelete": "Excluir",
        "Calendar:Permissions:Tableadd": "Adicionar",
        "AiCalendar:Permissions:Tableadd": "Adicionar",
        "Calendar:Permissions:Tableupdate": "Modificar",
        "AiCalendar:Permissions:Tableupdate": "Modificar",
        "Calendar:Permissions:Tabledelete": "Excluir",
        "AiCalendar:Permissions:Tabledelete": "Excluir",
        "Calendar:Permissions:TableallowShareSynchro": "Compartilhamento de Calendário",
        "AiCalendar:Permissions:TableallowShareSynchro": "Compartilhamento de Calendário",
        "Calendar:Permissions:TableallowEditMeetingScheduler": "Agendador de Reuniões",
        "Booking:Permissions:Tableadd": "Adicionar",
        "Booking:Permissions:Tableupdate": "Modificar",
        "Booking:Permissions:Tabledelete": "Excluir",
        "Parking:Permissions:Tableadd": "Adicionar",
        "Parking:Permissions:Tableupdate": "Modificar",
        "Parking:Permissions:Tabledelete": "Excluir",
        "Contact:Permissions:Tableadd": "Adicionar",
        "Contact:Permissions:Tableupdate": "Modificar",
        "Contact:Permissions:Tabledelete": "Excluir",
        "Keepass:Permissions:Tableadd": "Adicionar",
        "Keepass:Permissions:Tableupdate": "Modificar",
        "Keepass:Permissions:Tabledelete": "Excluir / Restaurar",
        "Permissions:CancelButton": "Cancelar",
        "Permissions:SaveButton": "Salvar",
        "Permissions:AddMemberButton": "Adicionar membro",
        "Permissions:GeneralSetting": "Permissões padrão",
        "Reminds:Permissions:addInfo": "O usuário poderá adicionar recordatorios",
        "Reminds:Permissions:updateInfo": "O usuário poderá modificar recordatorios",
        "Reminds:Permissions:deleteInfo": "O usuário poderá excluir recordatorios",
        "Calendar:Permissions:addInfo": "O usuário poderá adicionar eventos",
        "AiCalendar:Permissions:addInfo": "O usuário poderá adicionar eventos",
        "Calendar:Permissions:updateInfo": "O usuário poderá modificar eventos",
        "AiCalendar:Permissions:updateInfo": "O usuário poderá modificar eventos",
        "Calendar:Permissions:deleteInfo": "O usuário poderá excluir eventos",
        "AiCalendar:Permissions:deleteInfo": "O usuário poderá excluir eventos",
        "Calendar:Permissions:allowEditMeetingSchedulerInfo": "O usuário poderá gerenciar as configurações do agendador de reuniões",
        "Calendar:Permissions:allowShareSynchroInfo": "O usuário poderá compartilhar seus calendários sincronizados com todos",
        "AiCalendar:Permissions:allowShareSynchroInfo": "O usuário poderá compartilhar seus calendários sincronizados com todos",
        "Booking:Permissions:addInfo": "O usuário poderá adicionar reservas",
        "Booking:Permissions:updateInfo": "O usuário poderá modificar reservas",
        "Booking:Permissions:deleteInfo": "O usuário poderá excluir reservas",
        "Parking:Permissions:addInfo": "O usuário poderá adicionar reservas",
        "Parking:Permissions:updateInfo": "O usuário poderá modificar reservas",
        "Parking:Permissions:deleteInfo": "O usuário poderá excluir reservas",
        "Contact:Permissions:addInfo": "O usuário poderá adicionar contatos e grupos",
        "Contact:Permissions:updateInfo": "O usuário poderá modificar contatos e grupos",
        "Contact:Permissions:deleteInfo": "O usuário poderá excluir contatos e grupos",
        "Keepass:Permissions:addInfo": "O usuário poderá adicionar senhas",
        "Keepass:Permissions:updateInfo": "O usuário poderá modificar senhas",
        "Keepass:Permissions:deleteInfo": "O usuário poderá excluir e restaurar senhas",
        "Permissions:Owner": "Proprietário",
        "Permissions:Admin": "Administrador",
        "Permissions:Member": "Membro",
        "Permissions:MemberIsNotPlatinum": "Personalização exclusiva para assinantes Platinum",
        "Permissions:EveryoneDropdown": "Todos neste canal podem adicionar/editar/excluir {taskName}",
        "Permissions:CreatorDropdown": "Apenas o(s) proprietário(s) deste {appTitle} podem adicionar/editar/excluir {taskName}",
        "Permissions:CustomDropdown": "Personalizar permissões",
        "Permissions:Platinum": "Platinum",
        "Permissions:Premium": "<a href='https://admin.teams-pro.com/users' target='_blank'>Premium</a>",
        "Permissions:Free": "<a href='https://admin.teams-pro.com/users' target='_blank'>Grátis</a>",
        "Permissions:AssignLicense": "Clique para atribuir uma licença Platinum 🚀",
        "Permissions:Subscription": "Assinatura",
        "Booking:taskName": "reservas",
        "Parking:taskName": "reservas",
        "Reminds:taskName": "eventos",
        "Calendar:taskName": "eventos",
        "AiCalendar:taskName": "eventos",
        "Contact:taskName": "contatos e grupos",
        "Gantt:taskName": "tarefas",
        "Keepass:taskName": "senhas",
        AddMembers: "Adicionar membros",
        AddMembersTagLine: "Comece a digitar o endereço de e-mail da pessoa que deseja adicionar",
        EmailAddress: "Digite o endereço de e-mail",
        SaveAlert: "Suas modificações foram salvas com sucesso!",
        CancelTagLine: "Se você prosseguir agora, todas as alterações que você fez serão descartadas. Tem certeza de que deseja continuar?",
        Continue: "Continuar",
        Return: "Retornar",
        "Permissions:FreeRedirect": "Você está usando uma versão gratuita de {appTitle}.",
        "Permissions:PremiumRedirect": "Você está usando uma versão premium de {appTitle}.",
        "Sync:PremiumRedirect": "Você está usando uma versão premium de {appTitle}. Atualizar para Platinum 🚀 e gerenciar sincronizações!",
        "Sync:FreeRedirect": "Você está usando uma versão gratuita de {appTitle}. Atualizar para Platinum 🚀 e gerenciar sincronizações!",
        NotAllowed: "Você não tem permissão para alterar as permissões.",
        NotAllowedNotif: "Você não tem permissão para alterar essa configuração.",
        CancelModifications: "Cancelar modificações",
        "Sync:Title": "Sincronizar calendários",
        "Sync:Manage": "Gerenciar",
        "Sync:Synchronize": "Sincronizar",
        "Sync:Add": "Adicionar um calendário",
        "Sync:SyncCalendarTitle": "Sincronizar calendários com meu ",
        "Sync:ShareTitle": "Compartilhar meu ",
        "Sync:CalendarName": "Nome do calendário",
        "Sync:ICSLink": "Link .ICS do calendário",
        "Sync:PublicAddress": "Endereço público formato iCal",
        "Sync:TableName": "Nome",
        "Sync:TableColor": "Cor",
        "Sync:TableShow": "Compartilhar",
        "Sync:TableState": "Estado",
        "Sync:SynchronizeLine": "Para gerenciar todos os seus calendários em um só lugar, sincronize seu calendário.",
        "Sync:SyncCalendarTooltip": "Você pode sincronizar no máximo 3 calendários. Seu calendário será sincronizado a cada 15 minutos.",
        "Sync:SyncTitle": "Adicionar calendário externo",
        AddAlert: "Os membros foram adicionados com sucesso",
        "Sync:ICSInput": "Digite uma URL",
        "Sync:NameInput": "Digite um nome",
        "Sync:TableAction": "Ação",
        "Sync:ManageTooltip": "Você não tem nenhum calendário sincronizado",
        AddressTitle: "Endereço",
        AddAddress: "Digite aqui para pesquisar um endereço",
        Participants: "Participantes",
        NoParticipants: "Nenhum resultado encontrado",
        "Sync:TabTooltip": "Você precisa salvar/cancelar suas alterações",
        "Sync:DeleteCalendar": "Excluir calendário",
        "Sync:DeleteTagLine": "Se você prosseguir agora, seu calendário será excluído da sua visualização. Para vê-lo novamente, você precisará sincronizá-lo novamente.",
        "Sync:NotAllowToShare": "Os proprietários do calendário não permitem que você compartilhe seus calendários com outras pessoas",
        "Sync:ConnectionIssue": "Problema de conexão com o calendário detectado. Verifique a existência do calendário e o status da conexão para uma sincronização sem problemas.",
        "Permissions:CreatorRole": "Proprietário deste calendário",
        Synchronized: "Sincronizado",
        Unsynchronized: "Não sincronizado",
        "Sync:UnsynchronizedTooltip": "Problema de conexão com o calendário detectado. Verifique a existência do calendário e o status da conexão para uma sincronização sem problemas.",
        "Sync:ShareInfo": "Compartilhe este calendário com os membros em ",
        AddParticipantsButton: "Adicionar participantes",
        "Sync:getErrorMessage": "Ocorreu um erro com seu link ICS no calendário: ",
        "Permissions:ManageRoleTitle": "Confirmação de Alteração de Função",
        "Permissions:ManageRoleTagLine": "Você está prestes a mudar a função de um membro em sua guia. Ao prosseguir, você concederá direitos que não poderá revogar de um membro. Tem certeza de que deseja continuar?",
        NotifDialogHeader: "Configurações de notificação do Teams",
        RedirectToAppSource: "<p style='text-align: center;'>Estamos levando você ao Microsoft Marketplace. Se você não for redirecionado, <a target='_blank' href='{link}'>clique aqui</a>.</p>",
        WhatsNewsOn: "O que há de novo?",
        NewsSoon: "Notícias em breve!",
        NeedConsentTitle: "Precisa de consentimento",
        NeedConsent: "Para realizar esta ação, precisaremos de consentimento. Se você confirmar, será redirecionado para a página de consentimento.",
        NoAddress: "Nenhum resultado encontrado no Google Maps",
        YourInfo: "Suas informações",
        ChooseTime: "Escolher data e hora",
        IC_SuperAdminTitle: "Atenção",
        IC_SuperAdminExpiredCardMessage: "Suas informações de pagamento estão prestes a expirar, atualize-as para evitar interrupções no serviço.",
        IC_SuperAdminPaymentDueMessage: "Sua conta possui faturas pendentes. Por favor, regularize para evitar a interrupção do serviço.",
        IC_SuperAdminCTA: "Ir para o Centro Administrativo",
        IC_AdminTitle: "Atenção",
        IC_AdminExpiredCardMessage: "O método de pagamento associado à sua licença está prestes a expirar.",
        IC_AdminPaymentDueMessage: "Não foi possível processar o pagamento da sua licença, para evitar a interrupção do serviço",
        IC_AdminExpiredCardCTA: "Clique aqui para informar o seu Super Admin.",
        IC_AdminPaymentDueCTA: "clique aqui para notificar o seu Super Admin.",
        IC_NotifTitle: "Atenção solicitada",
        IC_NotifMessage: "Acesse {appName} para atualizações importantes",
        IC_SuccesNotifTitle: "Sucesso",
        IC_SuccesNotifMessage: "A notificação foi enviada com sucesso para o seu Super Admin.",
        PreventUnlockPremiumFeaturesOnMobile: "Para fazer upgrade para a versão Premium/Platinum, utilize o Teams no desktop ou na web.",
        GoToAdminCenter: "Ir para o Centro de Administração",
        PremiumMessage1: "Você está usando uma versão premium do {appTitle}.",
        ClickHere: "Clique aqui 🚀",
        PremiumMessage2: "para atualizar para Platinum e gerenciar permissões de forma mais eficaz!",
        DiscardMessageTitle: "Alterações não guardadas",
        DiscardChanges: "Eliminar",
        ContinueEditing: "Continuar a editar",
        DiscardMessage: "Pretende eliminar as edições ou continuar a editar?",
        VisitLink: "Visitar o link",
        SelectCustomize: "Para personalizar as permissões, selecione 'Personalizar permissões' acima",
        SaveBeforeSearch: "Salve suas alterações antes de pesquisar",
        AccessMaster: "Este usuário tem acesso à senha mestra",
        FeaturesNowAvailable: "Desfrute de todos os seus novos recursos agora!",
        KnowAboutFeatures: "Para saber mais sobre os recursos disponíveis para você, clique <a target='_blank' href='{link}'>aqui</a>!",
        Go: "Vamos lá!",
        NeedToBuyLicences: "Você precisa comprar licenças",
        HaveLicencesButNotEnough: "Você já tem algumas licenças, mas todas estão atribuídas. Você precisa comprar mais licenças para atribuir uma a si mesmo.",
        BuyMoreLicence: "Comprar mais licenças",
        GeneralPermissionsSettings: "Configurações gerais de permissões",
        CustomizedPermissionsSettings: "Configurações personalizadas de permissões",
        About: "Sobre",
        ReviewTitleJoin: "Junte-se a milhares de utilizadores que adoram o {appName}!",
        ReviewSubtitleShare: "Ajude outros a descobrir a aplicação partilhando a sua experiência",
        ReviewQuote: "As melhores aplicações nascem do feedback dos utilizadores",
        ThanksForYourRating: "Obrigado pela sua avaliação",
        ReviewFeedbackQuestion: "Adoraríamos o seu feedback! Leva apenas dois minutos.",
        WhatCouldWeImprove: "O que poderíamos melhorar? 💭",
        SubmitMyFeedback: "Enviar o meu feedback",
        FillCompleteFeedbackForm: "Preencher o nosso formulário de feedback completo",
        MaybeLater: "Talvez mais tarde",
        ReviewOnAppSource: "Avaliar no AppSource",
        Version: "Versão",
        UniqueID: "Identificador único",
        Copied: "Copiado!",
        Copy: "Copiar",
        CreatedBy: "Criado por",
        SuggestFeature: "Sugerir uma Funcionalidade",
        HelpCenter: "Centro de Ajuda",
        MoreApps: "Mais aplicativos",
        "Sync:NoUrlErrorMessage": "Por favor, preencha este campo com um link ics válido",
        "Sync:NoNameErrorMessage": "Por favor, adicione um nome a este calendário",
        "Sync:StartUrlErrorMessage": 'Por favor, insira um link ics válido, ele deve começar com "https://"',
        "Sync:EndUrlErrorMessage": 'Por favor, insira um link ics válido, ele deve terminar com ".ics"',
        no_reason: "Não preciso mais do aplicativo",
        technical_issue: "Problemas técnicos ou erros",
        bad_interface: "Difícil de usar ou entender",
        limited_features: "Recursos ou funcionalidades limitadas",
        switching_to_another_app: "Mudando para outra solução",
        temporary_uninstallation: "Desinstalação temporária (posso voltar)",
        UninstallReason: "Motivo",
        UninstallComment: "Comentário",
        "Rte:StartUrlErrorMessage": 'Por favor, insira um link válido, ele deve começar com "https://"',
        "Rte:InsertLink": "Inserir link",
        "Rte:TextToDisplay": "Texto a exibir",
        "Rte:Address": "Endereço",
        "Rte:AddressPlaceholder": "Link para uma página web existente",
        "Rte:NoHighlight": "Sem destaque",
        "Rte:ByDefault": "Por padrão",
        "Rte:Large": "Grande",
        "Rte:Medium": "Médio",
        "Rte:InsertImageLink": "Inserir link da imagem",
        "Rte:ImageAddressPlaceholder": "Link para uma imagem existente na web",
        UnlockPlatinum: "Desbloquear Platinum",
        UpgradePlatinumDescription: "Faça upgrade para Platinum para sua equipe. Gerencie permissões de usuário e acesse recursos avançados para administradores.",
        AdvancedTeamManagement: "Gestão avançada de equipe",
        ControlUserPermissions: "Controle permissões e níveis de acesso dos usuários",
        PlatinumFeatures: "Recursos Platinum",
        AccessAllPlatinumTools: "Acesse todas as ferramentas e capacidades Platinum",
        UnlockPremium: "Desbloquear Premium",
        CalendarUpgradePremiumDescription: "Faça upgrade para Premium para sua equipe. Planeje eventos recorrentes, organize-os e compartilhe seu calendário.",
        CalendarPremiumRecurrence: "Eventos recorrentes",
        CalendarPremiumRecurrenceDescription: "Repita seus eventos diariamente, semanalmente ou mensalmente",
        CalendarPremiumOrganize: "Tags e emoji",
        CalendarPremiumOrganizeDescription: "Organize e destaque seus eventos",
        CalendarPremiumShare: "Compartilhar e imprimir",
        CalendarPremiumShareDescription: "Compartilhe seus eventos e imprima seu calendário",
        PrioritySupport: "Suporte prioritário",
        DedicatedAssistance: "Assistência dedicada",
        LearnMoreFeatures: "Saiba mais sobre os recursos",
        "CookieDialogAnswer": "Faça do {appName} sua melhor ferramenta",
        "Experience": "Melhore minha experiência:",
        "ExperienceDesc": "Otimize o desempenho, corrija erros mais rapidamente e priorize os recursos que você mais usa.",
        "Offer": "Receba ofertas personalizadas:",
        "OfferDesc": "Sugestões, atualizações e promoções adaptadas ao seu uso. Sem spam. Você pode cancelar a inscrição a qualquer momento.",
        "AcceptAll": "Aceitar tudo",
        "Consent_Title": "Tire o máximo partido do {appName} ✨",
        "Consent_Subtitle": "Dicas e ofertas de produto por e-mail, além de estatísticas de utilização que nos ajudam a melhorar o {appName}. Opcional e desativado por predefinição. Pode alterar quando quiser.",
        "Consent_Footer": "Estas escolhas nunca afetam os seus dados no {appName}. O que cria na aplicação não é partilhado e nunca é usado para marketing.",
        "Consent_TrustRow": "Da Witivio · parceiro Microsoft · Cancele quando quiser",
        "Consent_Marketing": "Receber dicas e ofertas por e-mail",
        "Consent_MarketingDesc": "Cerca de uma vez por mês: dicas, novidades e ofertas de produto. Cancele a subscrição num clique, quando quiser.",
        "Consent_Experience": "Ajudar a melhorar o {appName}",
        "Consent_ExperienceDesc": "Partilhe a forma como usa o {appName} para corrigirmos erros mais depressa e criarmos as funcionalidades que mais utiliza. Nunca o conteúdo que cria na aplicação.",
        "Consent_EnableAll": "Aceitar tudo ✨",
        "Consent_Customize": "Personalizar",
        "Consent_Save": "Guardar as minhas escolhas",
        "Consent_Cancel": "Cancelar",
        "Consent_Saved": "Guardado ✅ Eis o que ativou:",
        "Consent_Declined": "Tudo pronto. Nada foi partilhado.",
        "Consent_ResultMarketing": "• Dicas e ofertas por e-mail",
        "Consent_ResultExperience": "• Estatísticas de melhoria do produto",
        "Consent_ManageHint": "Altere quando quiser no menu da barra de ferramentas: Opções de privacidade.",
        "Consent_PrivacyMenu": "Opções de privacidade",
        "ConsentScreen_Title": "Um último passo antes de começar",
        "ConsentScreen_Subtitle": "Esta aplicação funciona com a sua conta Microsoft 365. Permita o acesso uma única vez e está pronto.",
        "ConsentScreen_Allow": "Permitir acesso",
        "ConsentScreen_Waiting": "A aguardar a Microsoft…",
        "ConsentScreen_Finishing": "A preparar tudo…",
        "ConsentScreen_TryAgain": "Tentar novamente",
        "ConsentScreen_Hint": "Abre-se uma janela da Microsoft para confirmar. A sua palavra-passe nunca é partilhada com a aplicação.",
        "ConsentScreen_Revoke": "Pode remover este acesso a qualquer momento em {link}.",
        "ConsentScreen_FailedTitle": "O acesso não foi concedido",
        "ConsentScreen_FailedText": "A janela da Microsoft fechou antes de o acesso ser permitido. Se indicava \"Necessária aprovação do administrador\", só um administrador de TI pode aprovar a aplicação: envie-lhe a ligação abaixo.",
        "ConsentScreen_AdminToggle": "Necessária aprovação do administrador?",
        "ConsentScreen_AdminText": "Envie esta ligação ao seu administrador de TI. Depois de aprovada, o acesso é concedido a toda a sua organização.",
        "ConsentScreen_CopyLink": "Copiar ligação",
        "ConsentScreen_Copied": "Ligação copiada",
        "ConsentScreen_LinkLabel": "Ligação de aprovação do administrador",
        "OnboardingTour:MenuEntry": "Tour guiado",
        "OnboardingTour:HowToUse": "Como usar",
        "OnboardingTour:Step": "{current} de {total}",
        "OnboardingTour:Start": "Começar o tour",
        "OnboardingTour:Next": "Próximo",
        "OnboardingTour:Back": "Voltar",
        "OnboardingTour:Skip": "Pular",
        "OnboardingTour:Done": "Entendi",
    },
};
